/*============================================================================
  #Builder Libraries
==============================================================================*/

// Spectrum Colorpicker v1.8.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT
(function(c){"function"===typeof define&&define.amd?define(["jquery"],c):"object"==typeof exports&&"object"==typeof module?module.exports=c(require("jquery")):c(jQuery)})(function(c,Fa){function xa(p,g,l,q){for(var v=[],t=0;t<p.length;t++){var m=p[t];if(m){var w=tinycolor(m),x=.5>w.toHsl().l?"sp-thumb-el sp-thumb-dark":"sp-thumb-el sp-thumb-light";x+=tinycolor.equals(g,m)?" sp-thumb-active":"";m=w.toString(q.preferredFormat||"rgb");var C=Ga?"background-color:"+w.toRgbString():"filter:"+w.toFilter();
  v.push('<span title="'+m+'" data-color="'+w.toRgbString()+'" class="'+x+'"><span class="sp-thumb-inner" style="'+C+';" /></span>')}else v.push(c("<div />").append(c('<span data-color="" style="background-color:transparent;" class="sp-clear-display"></span>').attr("title",q.noColorSelectedText)).html())}return"<div class='sp-cf "+l+"'>"+v.join("")+"</div>"}function Pa(p,g){var l=c.extend({},na,p);l.callbacks={move:H(l.move,g),change:H(l.change,g),show:H(l.show,g),hide:H(l.hide,g),beforeShow:H(l.beforeShow,
  g)};return l}function ya(p,g){function l(){f.showPaletteOnly&&(f.showPalette=!0);za.text(f.showPaletteOnly?f.togglePaletteMoreText:f.togglePaletteLessText);if(f.palette){oa=f.palette.slice(0);G=c.isArray(oa[0])?oa:[oa];pa={};for(var a=0;a<G.length;a++)for(var b=0;b<G[a].length;b++){var d=tinycolor(G[a][b]).toRgbString();pa[d]=!0}}n.toggleClass("sp-flat",K);n.toggleClass("sp-input-disabled",!f.showInput);n.toggleClass("sp-alpha-enabled",f.showAlpha);n.toggleClass("sp-clear-enabled",Y);n.toggleClass("sp-buttons-disabled",
  !f.showButtons);n.toggleClass("sp-palette-buttons-disabled",!f.togglePaletteOnly);n.toggleClass("sp-palette-disabled",!f.showPalette);n.toggleClass("sp-palette-only",f.showPaletteOnly);n.toggleClass("sp-initial-disabled",!f.showInitial);n.addClass(f.className).addClass(f.containerClassName);I()}function q(){if(k&&window.localStorage){try{var a=window.localStorage[k].split(",#");1<a.length&&(delete window.localStorage[k],c.each(a,function(a,b){v(b)}))}catch(Ha){}try{L=window.localStorage[k].split(";")}catch(Ha){}}}
  function v(a){if(S){a=tinycolor(a).toRgbString();if(!pa[a]&&-1===c.inArray(a,L))for(L.push(a);L.length>na;)L.shift();if(k&&window.localStorage)try{window.localStorage[k]=L.join(";")}catch(Ha){}}}function t(){var a=[];if(f.showPalette)for(var b=0;b<L.length;b++){var d=tinycolor(L[b]).toRgbString();pa[d]||a.push(L[b])}return a.reverse().slice(0,f.maxSelectionSize)}function m(){var a=D(),b=c.map(G,function(b,d){return xa(b,a,"sp-palette-row sp-palette-row-"+d,f)});q();L&&b.push(xa(t(),a,"sp-palette-row sp-palette-row-selection",
  f));Ia.html(b.join(""))}function w(){if(f.showInitial){var a=Z,b=D();Ja.html(xa([a,b],b,"sp-palette-row-initial",f))}}function x(){(0>=A||0>=T||0>=d)&&I();aa=!0;n.addClass("sp-dragging");U=null;y.trigger("dragstart.spectrum",[D()])}function C(){aa=!1;n.removeClass("sp-dragging");y.trigger("dragstop.spectrum",[D()])}function Aa(){var a=M.val();null!==a&&""!==a||!Y?(a=tinycolor(a),a.isValid()?(N(a),O(),E()):M.addClass("sp-validation-error")):(N(null),O(),E())}function Ka(){h?P():ba()}function ba(){var a=
  c.Event("beforeShow.spectrum");if(h)I();else if(y.trigger(a,[D()]),!1!==B.beforeShow(D())&&!a.isDefaultPrevented()){for(a=0;a<V.length;a++)V[a]&&V[a].hide();h=!0;c(ha).on("keydown.spectrum",J);c(ha).on("click.spectrum",La);c(window).on("resize.spectrum",ca);da.addClass("sp-active");n.removeClass("sp-hidden");I();R();Z=D();w();B.show(Z);y.trigger("show.spectrum",[Z])}}function J(a){27===a.keyCode&&P()}function La(a){2==a.button||aa||(Qa||N(Z,!0),E(!0),P())}function P(){h&&!K&&(h=!1,c(ha).off("keydown.spectrum",
  J),c(ha).off("click.spectrum",La),c(window).off("resize.spectrum",ca),da.removeClass("sp-active"),n.addClass("sp-hidden"),B.hide(D()),y.trigger("hide.spectrum",[D()]))}function N(a,b){if(tinycolor.equals(a,D()))R();else{if(!a&&Y)W=!0;else{W=!1;var d=tinycolor(a);var e=d.toHsv();ia=e.h%360/360;ja=e.s;u=e.v;Q=e.a}R();d&&d.isValid()&&!b&&(ea=f.preferredFormat||d.getFormat())}}function D(a){a=a||{};return Y&&W?null:tinycolor.fromRatio({h:ia,s:ja,v:u,a:Math.round(1E3*Q)/1E3},{format:a.format||ea})}function O(){R();
  B.move(D());y.trigger("move.spectrum",[D()])}function R(){M.removeClass("sp-validation-error");r();var a=tinycolor.fromRatio({h:ia,s:1,v:1});qa.css("background-color",a.toHexString());a=ea;!(1>Q)||0===Q&&"name"===a||"hex"!==a&&"hex3"!==a&&"hex6"!==a&&"name"!==a||(a="rgb");var b=D({format:a}),d="";fa.removeClass("sp-clear-display");fa.css("background-color","transparent");if(!b&&Y)fa.addClass("sp-clear-display");else{d=b.toHexString();var e=b.toRgbString();Ga||1===b.alpha?fa.css("background-color",
  e):(fa.css("background-color","transparent"),fa.css("filter",b.toFilter()));if(f.showAlpha){e=b.toRgb();e.a=0;e=tinycolor(e).toRgbString();var z="linear-gradient(left, "+e+", "+d+")";X?ka.css("filter",tinycolor(e).toFilter({gradientType:1},d)):(ka.css("background","-webkit-"+z),ka.css("background","-moz-"+z),ka.css("background","-ms-"+z),ka.css("background","linear-gradient(to right, "+e+", "+d+")"))}d=b.toString(a)}f.showInput&&M.val(d);f.showPalette&&m();w()}function r(){var h=ja,f=u;Y&&W?(ra.hide(),
  sa.hide(),ta.hide()):(ra.show(),sa.show(),ta.show(),h*=T,f=A-f*A,h=Math.max(-a,Math.min(T-a,h-a)),f=Math.max(-a,Math.min(A-a,f-a)),ta.css({top:f+"px",left:h+"px"}),ra.css({left:Q*b-e/2+"px"}),sa.css({top:ia*d-z+"px"}))}function E(a){var b=D(),d="",e=!tinycolor.equals(b,Z);b&&(d=b.toString(ea),v(b));ua&&y.val(d);a&&e&&(B.change(b),y.trigger("change",[b]))}function I(){h&&(T=qa.width(),A=qa.height(),a=ta.height(),Ba.width(),d=Ba.height(),z=sa.height(),b=Ma.width(),e=ra.width(),K||(n.css("position",
  "absolute"),f.offset?n.offset(f.offset):n.offset(Ra(n,la))),r(),f.showPalette&&m(),y.trigger("reflow.spectrum"))}function H(){P();Ca=!0;y.attr("disabled",!0);la.addClass("sp-disabled")}var f=Pa(g,p),K=f.flat,S=f.showSelectionPalette,k=f.localStorageKey,F=f.theme,B=f.callbacks,ca=Sa(I,10),h=!1,aa=!1,T=0,A=0,a=0,d=0,b=0,e=0,z=0,ia=0,ja=0,u=0,Q=1,oa=[],G=[],pa={},L=f.selectionPalette.slice(0),na=f.maxSelectionSize,U=null,ha=p.ownerDocument,y=c(p),Ca=!1,n=c(Ta,ha).addClass(F),ya=n.find(".sp-picker-container"),
  qa=n.find(".sp-color"),ta=n.find(".sp-dragger"),Ba=n.find(".sp-hue"),sa=n.find(".sp-slider"),ka=n.find(".sp-alpha-inner"),Ma=n.find(".sp-alpha"),ra=n.find(".sp-alpha-handle"),M=n.find(".sp-input"),Ia=n.find(".sp-palette"),Ja=n.find(".sp-initial"),Na=n.find(".sp-cancel"),Da=n.find(".sp-clear"),Oa=n.find(".sp-choose"),za=n.find(".sp-palette-toggle"),ua=y.is("input"),Ua=ua&&"color"===y.attr("type")&&c.fn.spectrum.inputTypeColorSupport(),Ea=ua&&!K,da=Ea?c("<div class='sp-replacer'><div class='sp-preview'><div class='sp-preview-inner'></div></div><div class='sp-dd'>&#9660;</div></div>").addClass(F).addClass(f.className).addClass(f.replacerClassName):
  c([]),la=Ea?da:y,fa=da.find(".sp-preview-inner"),ma=f.color||ua&&y.val(),Z=!1,ea=f.preferredFormat,Qa=!f.showButtons||f.clickoutFiresChange,W=!ma,Y=f.allowEmpty&&!Ua;(function(){function a(a){a.data&&a.data.ignore?(N(c(a.target).closest(".sp-thumb-el").data("color")),O()):(N(c(a.target).closest(".sp-thumb-el").data("color")),O(),f.hideAfterPaletteSelect?(E(!0),P()):E());return!1}X&&n.find("*:not(input)").attr("unselectable","on");l();Ea&&y.after(da).hide();Y||Da.hide();if(K)y.after(n).hide();else{var e=
  "parent"===f.appendTo?y.parent():c(f.appendTo);1!==e.length&&(e=c("body"));e.append(n)}q();la.on("click.spectrum touchstart.spectrum",function(a){Ca||Ka();a.stopPropagation();c(a.target).is("input")||a.preventDefault()});(y.is(":disabled")||!0===f.disabled)&&H();n.click(Va);M.change(Aa);M.on("paste",function(){setTimeout(Aa,1)});M.keydown(function(a){13==a.keyCode&&Aa()});Na.text(f.cancelText);Na.on("click.spectrum",function(a){a.stopPropagation();a.preventDefault();N(Z,!0);E(!0);P()});Da.attr("title",
  f.clearText);Da.on("click.spectrum",function(a){a.stopPropagation();a.preventDefault();W=!0;O();K&&E(!0)});Oa.text(f.chooseText);Oa.on("click.spectrum",function(a){a.stopPropagation();a.preventDefault();X&&M.is(":focus")&&M.trigger("change");M.hasClass("sp-validation-error")||(E(!0),P())});za.text(f.showPaletteOnly?f.togglePaletteMoreText:f.togglePaletteLessText);za.on("click.spectrum",function(a){a.stopPropagation();a.preventDefault();f.showPaletteOnly=!f.showPaletteOnly;f.showPaletteOnly||K||n.css("left",
  "-="+(ya.outerWidth(!0)+5));l()});va(Ma,function(a,d,e){Q=a/b;W=!1;e.shiftKey&&(Q=Math.round(10*Q)/10);O()},x,C);va(Ba,function(a,b){ia=parseFloat(b/d);W=!1;f.showAlpha||(Q=1);O()},x,C);va(qa,function(a,b,d){d.shiftKey?U||(U=Math.abs(a-ja*T)>Math.abs(b-(A-u*A))?"x":"y"):U=null;d=!U||"y"===U;U&&"x"!==U||(ja=parseFloat(a/T));d&&(u=parseFloat((A-b)/A));W=!1;f.showAlpha||(Q=1);O()},x,C);ma?(N(ma),R(),ea=f.preferredFormat||tinycolor(ma).format,v(ma)):R();K&&ba();e=X?"mousedown.spectrum":"click.spectrum touchstart.spectrum";
  Ia.on(e,".sp-thumb-el",a);Ja.on(e,".sp-thumb-el:nth-child(1)",{ignore:!0},a)})();var wa={show:ba,hide:P,toggle:Ka,reflow:I,option:function(a,b){if(a===Fa)return c.extend({},f);if(b===Fa)return f[a];f[a]=b;"preferredFormat"===a&&(ea=f.preferredFormat);l()},enable:function(){Ca=!1;y.attr("disabled",!1);la.removeClass("sp-disabled")},disable:H,offset:function(a){f.offset=a;I()},set:function(a){N(a);E()},get:D,destroy:function(){y.show();la.off("click.spectrum touchstart.spectrum");n.remove();da.remove();
  V[wa.id]=null},container:n};wa.id=V.push(wa)-1;return wa}function Ra(p,g){var l=p.outerWidth(),q=p.outerHeight(),v=g.outerHeight(),t=p[0].ownerDocument,m=t.documentElement,w=m.clientWidth+c(t).scrollLeft();t=m.clientHeight+c(t).scrollTop();m=g.offset();var x=m.left,C=m.top;C+=v;x-=Math.min(x,x+l>w&&w>l?Math.abs(x+l-w):0);C-=Math.min(C,C+q>t&&t>q?Math.abs(q+v-0):0);return{top:C,bottom:m.bottom,left:x,right:m.right,width:m.width,height:m.height}}function G(){}function Va(c){c.stopPropagation()}function H(c,
  g){var p=Array.prototype.slice,q=p.call(arguments,2);return function(){return c.apply(g,q.concat(p.call(arguments)))}}function va(p,g,l,q){function v(c){c.stopPropagation&&c.stopPropagation();c.preventDefault&&c.preventDefault();c.returnValue=!1}function t(c){if(x){if(X&&9>w.documentMode&&!c.button)return m();var l=c.originalEvent&&c.originalEvent.touches&&c.originalEvent.touches[0],q=Math.max(0,Math.min((l&&l.pageX||c.pageX)-C.left,H));l=Math.max(0,Math.min((l&&l.pageY||c.pageY)-C.top,G));ba&&v(c);
  g.apply(p,[q,l,c])}}function m(){x&&(c(w).off(J),c(w.body).removeClass("sp-dragging"),setTimeout(function(){q.apply(p,arguments)},0));x=!1}g=g||function(){};l=l||function(){};q=q||function(){};var w=document,x=!1,C={},G=0,H=0,ba="ontouchstart"in window,J={};J.selectstart=v;J.dragstart=v;J["touchmove mousemove"]=t;J["touchend mouseup"]=m;c(p).on("touchstart mousedown",function(g){(g.which?3==g.which:2==g.button)||x||!1===l.apply(p,arguments)||(x=!0,G=c(p).height(),H=c(p).width(),C=c(p).offset(),c(w).on(J),
  c(w.body).addClass("sp-dragging"),t(g),v(g))})}function Sa(c,g,l){var p;return function(){var v=this,q=arguments,m=function(){p=null;c.apply(v,q)};l&&clearTimeout(p);if(l||!p)p=setTimeout(m,g)}}var na={beforeShow:G,move:G,change:G,show:G,hide:G,color:!1,flat:!1,showInput:!1,allowEmpty:!1,showButtons:!0,clickoutFiresChange:!0,showInitial:!1,showPalette:!1,showPaletteOnly:!1,hideAfterPaletteSelect:!1,togglePaletteOnly:!1,showSelectionPalette:!0,localStorageKey:!1,appendTo:"body",maxSelectionSize:7,
  cancelText:"cancel",chooseText:"choose",togglePaletteMoreText:"more",togglePaletteLessText:"less",clearText:"Clear Color Selection",noColorSelectedText:"No Color Selected",preferredFormat:!1,className:"",containerClassName:"",replacerClassName:"",showAlpha:!1,theme:"sp-light",palette:["#ffffff #000000 #ff0000 #ff8000 #ffff00 #008000 #0000ff #4b0082 #9400d3".split(" ")],selectionPalette:[],disabled:!1,offset:null},V=[],X=!!/msie/i.exec(window.navigator.userAgent),Ga=function(){var c=document.createElement("div").style;
  c.cssText="background-color:rgba(0,0,0,.5)";return!!~(""+c.backgroundColor).indexOf("rgba")||!!~(""+c.backgroundColor).indexOf("hsla")}(),Ta=function(){var c="";if(X)for(var g=1;6>=g;g++)c+="<div class='sp-"+g+"'></div>";return["<div class='sp-container sp-hidden'><div class='sp-palette-container'><div class='sp-palette sp-thumb sp-cf'></div><div class='sp-palette-button-container sp-cf'><button type='button' class='sp-palette-toggle'></button></div></div><div class='sp-picker-container'><div class='sp-top sp-cf'><div class='sp-fill'></div><div class='sp-top-inner'><div class='sp-color'><div class='sp-sat'><div class='sp-val'><div class='sp-dragger'></div></div></div></div><div class='sp-clear sp-clear-display'></div><div class='sp-hue'><div class='sp-slider'></div>",
  c,"</div></div><div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div></div><div class='sp-input-container sp-cf'><input class='sp-input' type='text' spellcheck='false'  /></div><div class='sp-initial sp-thumb sp-cf'></div><div class='sp-button-container sp-cf'><a class='sp-cancel' href='#'></a><button type='button' class='sp-choose'></button></div></div></div>"].join("")}();c.fn.spectrum=function(p,g){if("string"==typeof p){var l=this,q=Array.prototype.slice.call(arguments,
  1);this.each(function(){var g=V[c(this).data("spectrum.id")];if(g){var t=g[p];if(!t)throw Error("Spectrum: no such method: '"+p+"'");"get"==p?l=g.get():"container"==p?l=g.container:"option"==p?l=g.option.apply(g,q):"destroy"==p?(g.destroy(),c(this).removeData("spectrum.id")):t.apply(g,q)}});return l}return this.spectrum("destroy").each(function(){var g=c.extend({},c(this).data(),p);g=ya(this,g);c(this).data("spectrum.id",g.id)})};c.fn.spectrum.load=!0;c.fn.spectrum.loadOpts={};c.fn.spectrum.draggable=
  va;c.fn.spectrum.defaults=na;c.fn.spectrum.inputTypeColorSupport=function g(){if("undefined"===typeof g._cachedResult){var l=c("<input type='color'/>")[0];g._cachedResult="color"===l.type&&""!==l.value}return g._cachedResult};c.spectrum={};c.spectrum.localization={};c.spectrum.palettes={};c.fn.spectrum.processNativeColorInputs=function(){var g=c("input[type=color]");g.length&&!c.fn.spectrum.inputTypeColorSupport()&&g.spectrum({preferredFormat:"hex6"})};(function(){function c(a,d,b){a=r(a,255);d=r(d,
  255);b=r(b,255);var e=B(a,d,b),z=F(a,d,b),c=(e+z)/2;if(e==z)var f=z=0;else{var h=e-z;z=.5<c?h/(2-e-z):h/(e+z);switch(e){case a:f=(d-b)/h+(d<b?6:0);break;case d:f=(b-a)/h+2;break;case b:f=(a-d)/h+4}f/=6}return{h:f,s:z,l:c}}function l(a,d,b){function e(a,b,d){0>d&&(d+=1);1<d&&--d;return d<1/6?a+6*(b-a)*d:.5>d?b:d<2/3?a+(b-a)*(2/3-d)*6:a}a=r(a,360);d=r(d,100);b=r(b,100);if(0===d)b=d=a=b;else{var z=.5>b?b*(1+d):b+d-b*d,c=2*b-z;b=e(c,z,a+1/3);d=e(c,z,a);a=e(c,z,a-1/3)}return{r:255*b,g:255*d,b:255*a}}function q(a,
  d,b){a=r(a,255);d=r(d,255);b=r(b,255);var e=B(a,d,b),c=F(a,d,b),f=e-c;if(e==c)var h=0;else{switch(e){case a:h=(d-b)/f+(d<b?6:0);break;case d:h=(b-a)/f+2;break;case b:h=(a-d)/f+4}h/=6}return{h:h,s:0===e?0:f/e,v:e}}function v(a,d,b,e){a=[E(k(a).toString(16)),E(k(d).toString(16)),E(k(b).toString(16))];return e&&a[0].charAt(0)==a[0].charAt(1)&&a[1].charAt(0)==a[1].charAt(1)&&a[2].charAt(0)==a[2].charAt(1)?a[0].charAt(0)+a[1].charAt(0)+a[2].charAt(0):a.join("")}function t(a,d,b,e){return[E(Math.round(255*
  parseFloat(e)).toString(16)),E(k(a).toString(16)),E(k(d).toString(16)),E(k(b).toString(16))].join("")}function m(a,d){d=0===d?0:d||10;var b=h(a).toHsl();b.s-=d/100;b.s=F(1,B(0,b.s));return h(b)}function w(a,d){d=0===d?0:d||10;var b=h(a).toHsl();b.s+=d/100;b.s=F(1,B(0,b.s));return h(b)}function x(a){return h(a).desaturate(100)}function C(a,d){d=0===d?0:d||10;var b=h(a).toHsl();b.l+=d/100;b.l=F(1,B(0,b.l));return h(b)}function G(a,d){d=0===d?0:d||10;var b=h(a).toRgb();b.r=B(0,F(255,b.r-k(255*-(d/100))));
  b.g=B(0,F(255,b.g-k(255*-(d/100))));b.b=B(0,F(255,b.b-k(255*-(d/100))));return h(b)}function H(a,d){d=0===d?0:d||10;var b=h(a).toHsl();b.l-=d/100;b.l=F(1,B(0,b.l));return h(b)}function ba(a,d){var b=h(a).toHsl(),e=(k(b.h)+d)%360;b.h=0>e?360+e:e;return h(b)}function J(a){a=h(a).toHsl();a.h=(a.h+180)%360;return h(a)}function V(a){var d=h(a).toHsl(),b=d.h;return[h(a),h({h:(b+120)%360,s:d.s,l:d.l}),h({h:(b+240)%360,s:d.s,l:d.l})]}function P(a){var d=h(a).toHsl(),b=d.h;return[h(a),h({h:(b+90)%360,s:d.s,
  l:d.l}),h({h:(b+180)%360,s:d.s,l:d.l}),h({h:(b+270)%360,s:d.s,l:d.l})]}function N(a){var d=h(a).toHsl(),b=d.h;return[h(a),h({h:(b+72)%360,s:d.s,l:d.l}),h({h:(b+216)%360,s:d.s,l:d.l})]}function D(a,d,b){d=d||6;b=b||30;var e=h(a).toHsl();b=360/b;a=[h(a)];for(e.h=(e.h-(b*d>>1)+720)%360;--d;)e.h=(e.h+b)%360,a.push(h(e));return a}function O(a,d){d=d||6;var b=h(a).toHsv(),e=b.h,c=b.s;b=b.v;for(var f=[],g=1/d;d--;)f.push(h({h:e,s:c,v:b})),b=(b+g)%1;return f}function R(a){a=parseFloat(a);if(isNaN(a)||0>a||
  1<a)a=1;return a}function r(a,d){var b=a;"string"==typeof b&&-1!=b.indexOf(".")&&1===parseFloat(b)&&(a="100%");b="string"===typeof a&&-1!=a.indexOf("%");a=F(d,B(0,parseFloat(a)));b&&(a=parseInt(a*d,10)/100);return 1E-6>S.abs(a-d)?1:a%d/parseFloat(d)}function E(a){return 1==a.length?"0"+a:""+a}function I(a){1>=a&&(a=100*a+"%");return a}var X=/^[\s,#]+/,f=/\s+$/,K=0,S=Math,k=S.round,F=S.min,B=S.max,ca=S.random,h=function(a,d){var b,e;a=a?a:"";d=d||{};if(a instanceof h)return a;if(!(this instanceof h))return new h(a,
  d);var c=a;var g={r:0,g:0,b:0};var q=1;var u=b=!1;if("string"==typeof c)a:{c=c.replace(X,"").replace(f,"").toLowerCase();var m=!1;if(aa[c])c=aa[c],m=!0;else if("transparent"==c){c={r:0,g:0,b:0,a:0,format:"name"};break a}c=(e=A.rgb.exec(c))?{r:e[1],g:e[2],b:e[3]}:(e=A.rgba.exec(c))?{r:e[1],g:e[2],b:e[3],a:e[4]}:(e=A.hsl.exec(c))?{h:e[1],s:e[2],l:e[3]}:(e=A.hsla.exec(c))?{h:e[1],s:e[2],l:e[3],a:e[4]}:(e=A.hsv.exec(c))?{h:e[1],s:e[2],v:e[3]}:(e=A.hsva.exec(c))?{h:e[1],s:e[2],v:e[3],a:e[4]}:(e=A.hex8.exec(c))?
  {a:parseInt(e[1],16)/255,r:parseInt(e[2],16),g:parseInt(e[3],16),b:parseInt(e[4],16),format:m?"name":"hex8"}:(e=A.hex6.exec(c))?{r:parseInt(e[1],16),g:parseInt(e[2],16),b:parseInt(e[3],16),format:m?"name":"hex"}:(e=A.hex3.exec(c))?{r:parseInt(e[1]+""+e[1],16),g:parseInt(e[2]+""+e[2],16),b:parseInt(e[3]+""+e[3],16),format:m?"name":"hex"}:!1}if("object"==typeof c){if(c.hasOwnProperty("r")&&c.hasOwnProperty("g")&&c.hasOwnProperty("b"))g=c.g,b=c.b,g={r:255*r(c.r,255),g:255*r(g,255),b:255*r(b,255)},b=
  !0,u="%"===String(c.r).substr(-1)?"prgb":"rgb";else if(c.hasOwnProperty("h")&&c.hasOwnProperty("s")&&c.hasOwnProperty("v")){c.s=I(c.s);c.v=I(c.v);u=c.h;m=c.s;g=c.v;u=6*r(u,360);m=r(m,100);g=r(g,100);b=S.floor(u);var t=u-b;u=g*(1-m);e=g*(1-t*m);m=g*(1-(1-t)*m);b%=6;g={r:255*[g,e,u,u,m,g][b],g:255*[m,g,g,e,u,u][b],b:255*[u,u,m,g,g,e][b]};b=!0;u="hsv"}else c.hasOwnProperty("h")&&c.hasOwnProperty("s")&&c.hasOwnProperty("l")&&(c.s=I(c.s),c.l=I(c.l),g=l(c.h,c.s,c.l),b=!0,u="hsl");c.hasOwnProperty("a")&&
  (q=c.a)}q=R(q);c=c.format||u;u=F(255,B(g.r,0));e=F(255,B(g.g,0));g=F(255,B(g.b,0));this._originalInput=a;this._r=u;this._g=e;this._b=g;this._a=q;this._roundA=k(1E3*this._a)/1E3;this._format=d.format||c;this._gradientType=d.gradientType;1>this._r&&(this._r=k(this._r));1>this._g&&(this._g=k(this._g));1>this._b&&(this._b=k(this._b));this._ok=b;this._tc_id=K++};h.prototype={isDark:function(){return 128>this.getBrightness()},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},
  getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var a=this.toRgb();return(299*a.r+587*a.g+114*a.b)/1E3},setAlpha:function(a){this._a=R(a);this._roundA=k(1E3*this._a)/1E3;return this},toHsv:function(){var a=q(this._r,this._g,this._b);return{h:360*a.h,s:a.s,v:a.v,a:this._a}},toHsvString:function(){var a=q(this._r,this._g,this._b),d=k(360*a.h),b=k(100*a.s);a=k(100*a.v);return 1==this._a?"hsv("+
  d+", "+b+"%, "+a+"%)":"hsva("+d+", "+b+"%, "+a+"%, "+this._roundA+")"},toHsl:function(){var a=c(this._r,this._g,this._b);return{h:360*a.h,s:a.s,l:a.l,a:this._a}},toHslString:function(){var a=c(this._r,this._g,this._b),d=k(360*a.h),b=k(100*a.s);a=k(100*a.l);return 1==this._a?"hsl("+d+", "+b+"%, "+a+"%)":"hsla("+d+", "+b+"%, "+a+"%, "+this._roundA+")"},toHex:function(a){return v(this._r,this._g,this._b,a)},toHexString:function(a){return"#"+this.toHex(a)},toHex8:function(){return t(this._r,this._g,this._b,
  this._a)},toHex8String:function(){return"#"+this.toHex8()},toRgb:function(){return{r:k(this._r),g:k(this._g),b:k(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+k(this._r)+", "+k(this._g)+", "+k(this._b)+")":"rgba("+k(this._r)+", "+k(this._g)+", "+k(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:k(100*r(this._r,255))+"%",g:k(100*r(this._g,255))+"%",b:k(100*r(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+k(100*r(this._r,
  255))+"%, "+k(100*r(this._g,255))+"%, "+k(100*r(this._b,255))+"%)":"rgba("+k(100*r(this._r,255))+"%, "+k(100*r(this._g,255))+"%, "+k(100*r(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":1>this._a?!1:T[v(this._r,this._g,this._b,!0)]||!1},toFilter:function(a){var d="#"+t(this._r,this._g,this._b,this._a),b=d,c=this._gradientType?"GradientType = 1, ":"";a&&(b=h(a).toHex8String());return"progid:DXImageTransform.Microsoft.gradient("+c+"startColorstr="+d+",endColorstr="+
  b+")"},toString:function(a){var d=!!a;a=a||this._format;var b=!1,c=1>this._a&&0<=this._a;if(!d&&c&&("hex"===a||"hex6"===a||"hex3"===a||"name"===a))return"name"===a&&0===this._a?this.toName():this.toRgbString();"rgb"===a&&(b=this.toRgbString());"prgb"===a&&(b=this.toPercentageRgbString());if("hex"===a||"hex6"===a)b=this.toHexString();"hex3"===a&&(b=this.toHexString(!0));"hex8"===a&&(b=this.toHex8String());"name"===a&&(b=this.toName());"hsl"===a&&(b=this.toHslString());"hsv"===a&&(b=this.toHsvString());
  return b||this.toHexString()},_applyModification:function(a,d){var b=a.apply(null,[this].concat([].slice.call(d)));this._r=b._r;this._g=b._g;this._b=b._b;this.setAlpha(b._a);return this},lighten:function(){return this._applyModification(C,arguments)},brighten:function(){return this._applyModification(G,arguments)},darken:function(){return this._applyModification(H,arguments)},desaturate:function(){return this._applyModification(m,arguments)},saturate:function(){return this._applyModification(w,arguments)},
  greyscale:function(){return this._applyModification(x,arguments)},spin:function(){return this._applyModification(ba,arguments)},_applyCombination:function(a,d){return a.apply(null,[this].concat([].slice.call(d)))},analogous:function(){return this._applyCombination(D,arguments)},complement:function(){return this._applyCombination(J,arguments)},monochromatic:function(){return this._applyCombination(O,arguments)},splitcomplement:function(){return this._applyCombination(N,arguments)},triad:function(){return this._applyCombination(V,
  arguments)},tetrad:function(){return this._applyCombination(P,arguments)}};h.fromRatio=function(a,d){if("object"==typeof a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]="a"===c?a[c]:I(a[c]));a=b}return h(a,d)};h.equals=function(a,d){return a&&d?h(a).toRgbString()==h(d).toRgbString():!1};h.random=function(){return h.fromRatio({r:ca(),g:ca(),b:ca()})};h.mix=function(a,d,b){b=0===b?0:b||50;a=h(a).toRgb();d=h(d).toRgb();b/=100;var c=2*b-1,f=d.a-a.a;c=((-1==c*f?c:(c+f)/(1+c*f))+1)/2;f=1-c;return h({r:d.r*
  c+a.r*f,g:d.g*c+a.g*f,b:d.b*c+a.b*f,a:d.a*b+a.a*(1-b)})};h.readability=function(a,d){var b=h(a),c=h(d),f=b.toRgb(),g=c.toRgb();b=b.getBrightness();c=c.getBrightness();return{brightness:Math.abs(b-c),color:Math.max(f.r,g.r)-Math.min(f.r,g.r)+Math.max(f.g,g.g)-Math.min(f.g,g.g)+Math.max(f.b,g.b)-Math.min(f.b,g.b)}};h.isReadable=function(a,d){var b=h.readability(a,d);return 125<b.brightness&&500<b.color};h.mostReadable=function(a,d){for(var b=null,c=0,f=!1,g=0;g<d.length;g++){var k=h.readability(a,d[g]),
  l=125<k.brightness&&500<k.color;k=k.brightness/125*3+k.color/500;if(l&&!f||l&&f&&k>c||!l&&!f&&k>c)f=l,c=k,b=h(d[g])}return b};var aa=h.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",
  cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",
  floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",
  lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",
  mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",
  sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},T=h.hexNames=function(a){var c={},b;for(b in a)a.hasOwnProperty(b)&&(c[a[b]]=b);return c}(aa),A={rgb:/rgb[\s|\(]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))\s*\)?/,
  rgba:/rgba[\s|\(]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))\s*\)?/,hsl:/hsl[\s|\(]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))\s*\)?/,hsla:/hsla[\s|\(]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))\s*\)?/,
  hsv:/hsv[\s|\(]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))\s*\)?/,hsva:/hsva[\s|\(]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))[,|\s]+((?:[-\+]?\d*\.\d+%?)|(?:[-\+]?\d+%?))\s*\)?/,hex3:/^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex8:/^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/};
  window.tinycolor=h})();c(function(){c.fn.spectrum.load&&c.fn.spectrum.processNativeColorInputs()})});

/*
  * jQuery Guillotine Plugin v1.3.1
  * http://matiasgagliano.github.com/guillotine/
  *
  * Copyright 2014, Matías Gagliano.
  * Dual licensed under the MIT or GPLv3 licenses.
  * http://opensource.org/licenses/MIT
  * http://opensource.org/licenses/GPL-3.0
  *
  */
(function(){"use strict";var t,i,e,h,s,o,n,a,r,l,d,u,p,g=function(t,i){return function(){return t.apply(i,arguments)}},c=[].indexOf||function(t){for(var i=0,e=this.length;e>i;i++)if(i in this&&this[i]===t)return i;return-1};t=jQuery,r="guillotine",l="guillotine",s={start:"touchstart."+l+" mousedown."+l,move:"touchmove."+l+" mousemove."+l,stop:"touchend."+l+" mouseup."+l},h={width:400,height:300,zoomStep:.1,init:null,eventOnChange:null,onChange:null},d=/touch/i,a=function(t){return d.test(t.type)},u=function(t){return a(t)?1===t.originalEvent.changedTouches.length:1===t.which},o=function(t){return a(t)&&(t=t.originalEvent.touches[0]),{x:t.pageX,y:t.pageY}},e=function(){var t,i,h,s,o,n,a,r,l,d;for(t=!1,n=["webkit","Moz","O","ms","Khtml"],l={transform:"transform"},h=0,s=n.length;s>h;h++)o=n[h],l[o+"Transform"]="-"+o.toLowerCase()+"-transform";i=document.createElement("img"),document.body.insertBefore(i,null);for(r in l)if(a=l[r],void 0!==i.style[r]&&(i.style[r]="rotate(90deg)",d=window.getComputedStyle(i).getPropertyValue(a),null!=d&&d.length&&"none"!==d)){t=!0;break}return document.body.removeChild(i),(e=t?function(){return!0}:function(){return!1})()},n=function(i){return t(i).css({"-webkit-perspective":1e3,perspective:1e3,"-webkit-backface-visibility":"hidden","backface-visibility":"hidden"})},i=function(){function i(i,e){this._drag=g(this._drag,this),this._unbind=g(this._unbind,this),this._start=g(this._start,this),this.op=t.extend(!0,{},h,e,t(i).data(r)),this.enabled=!0,this.zoomInFactor=1+this.op.zoomStep,this.zoomOutFactor=1/this.zoomInFactor,this.glltRatio=this.op.height/this.op.width,this.width=this.height=this.left=this.top=this.angle=0,this.data={scale:1,angle:0,x:0,y:0,w:this.op.width,h:this.op.height,minScale:1,zoomStep:+this.op.zoomStep.toFixed(2),maxScale:+this.op.maxScale.toFixed(2)},this._wrap(i),null!=this.op.init&&this._init(),(this.width<1||this.height<1)&&this._fit()&&this._center(),n(this.$el),this.$el.on(s.start,this._start)}return i.prototype._wrap=function(i){var e,h,s,o,n,a;return h=t(i),"IMG"===i.tagName?i.naturalWidth?(a=i.naturalWidth,o=i.naturalHeight):(h.addClass("guillotine-sample"),a=h.width(),o=h.height(),h.removeClass("guillotine-sample")):(a=h.width(),o=h.height()),this.width=a/this.op.width,this.height=o/this.op.height,e=t("<div>").addClass("guillotine-canvas"),e.css({width:100*this.width+"%",height:100*this.height+"%",top:0,left:0}),e=h.wrap(e).parent(),this.widthReal=a,this.heightReal=o,this.widthOrig=this.width,this.heightOrig=this.height,this.data.minScale=+Math.max.apply(this,[this.op.width/this.widthReal,this.op.height/this.heightReal]).toFixed(2),n=this.op.height/this.op.width*100+"%",s=t("<div>").addClass("guillotine-window"),s.css({width:"100%",height:"auto","padding-top":n}),s=e.wrap(s).parent(),this.$el=h,this.el=h[0],this.$canvas=e,this.canvas=e[0],this.$gllt=s,this.gllt=s[0],this.$document=t(i.ownerDocument),this.$body=t("body",this.$document)},i.prototype._unwrap=function(){return this.$el.removeAttr("style"),this.$el.insertBefore(this.gllt),this.$gllt.remove()},i.prototype._init=function(){var t,i,e;return i=this.op.init,(e=parseFloat(i.scale))&&this._zoom(e),(t=parseInt(i.angle))&&this._rotate(t),this._offset(parseInt(i.x)/this.op.width||0,parseInt(i.y)/this.op.height||0)},i.prototype._start=function(t){return this.enabled&&u(t)?(t.preventDefault(),t.stopImmediatePropagation(),this.p=o(t),this._bind()):void 0},i.prototype._bind=function(){return this.$body.addClass("guillotine-dragging"),this.$document.on(s.move,this._drag),this.$document.on(s.stop,this._unbind)},i.prototype._unbind=function(t){return this.$body.removeClass("guillotine-dragging"),this.$document.off(s.move,this._drag),this.$document.off(s.stop,this._unbind),null!=t?this._trigger("drag"):void 0},i.prototype._trigger=function(t){return null!=this.op.eventOnChange&&this.$el.trigger(this.op.eventOnChange,[this.data,t]),"function"==typeof this.op.onChange?this.op.onChange.call(this.el,this.data,t):void 0},i.prototype._drag=function(t){var i,e,h,s,n;return t.preventDefault(),t.stopImmediatePropagation(),s=o(t),i=s.x-this.p.x,e=s.y-this.p.y,this.p=s,h=0===i?null:this.left-i/this.gllt.clientWidth,n=0===e?null:this.top-e/this.gllt.clientHeight,this._offset(h,n)},i.prototype._offset=function(t,i){return(t||0===t)&&(0>t&&(t=0),t>this.width-1&&(t=this.width-1),this.canvas.style.left=(100*-t).toFixed(2)+"%",this.left=t,this.data.x=Math.round(t*this.op.width)),i||0===i?(0>i&&(i=0),i>this.height-1&&(i=this.height-1),this.canvas.style.top=(100*-i).toFixed(2)+"%",this.top=i,this.data.y=Math.round(i*this.op.height)):void 0},i.prototype._zoom=function(t){var i,e,h,s;if(t>0&&1!==t&&(s=this.width,i=this.height,!this.op.maxScale||this.data.scale*t<=this.op.maxScale))return s*t>1&&i*t>1?(this.width*=t,this.height*=t,this.canvas.style.width=(100*this.width).toFixed(2)+"%",this.canvas.style.height=(100*this.height).toFixed(2)+"%",this.data.scale*=t):(this._fit(),t=this.width/s),e=(this.left+.5)*t-.5,h=(this.top+.5)*t-.5,this._offset(e,h)},i.prototype._zoomScale=function(t){var i;return t=parseFloat(t),i=t/this.data.scale,this._zoom(i)},i.prototype._fit=function(){var t,i;return t=this.width,i=this.height/this.width,i>1?(this.width=1,this.height=i):(this.width=1/i,this.height=1),this.canvas.style.width=(100*this.width).toFixed(2)+"%",this.canvas.style.height=(100*this.height).toFixed(2)+"%",this.data.scale*=this.width/t},i.prototype._center=function(){return this._offset((this.width-1)/2,(this.height-1)/2)},i.prototype._rotate=function(t){var i,h,s,o,n,a,r,l;if(e()&&0!==t&&t%90===0)return this.angle=(this.angle+t)%360,this.angle<0&&(this.angle=360+this.angle),t%180!==0&&(l=this.widthReal,s=this.heightReal,this.angle%180!==0&&(o=[s,l],l=o[0],s=o[1]),this.data.minScale=+Math.max.apply(this,[this.op.width/l,this.op.height/s]).toFixed(2),h=this.op.height/this.op.width,n=[this.height*h,this.width/h],this.width=n[0],this.height=n[1],this.width<1||this.height<1?this._fit():(this.canvas.style.width=100*this.width+"%",this.canvas.style.height=100*this.height+"%")),a=[1,1],l=a[0],s=a[1],this.angle%180!==0&&(i=this.height/this.width*h,r=[i,1/i],l=r[0],s=r[1]),this.el.style.width=100*l+"%",this.el.style.height=100*s+"%",this.el.style.left=(1-l)/2*100+"%",this.el.style.top=(1-s)/2*100+"%",this.$el.css({transform:"rotate("+this.angle+"deg)"}),this._center(),this.data.angle=this.angle},i.prototype.rotateLeft=function(){return this.enabled&&(this._rotate(-90),this._trigger("rotateLeft"))},i.prototype.rotateRight=function(){return this.enabled&&(this._rotate(90),this._trigger("rotateRight"))},i.prototype.center=function(){return this.enabled&&(this._center(),this._trigger("center"))},i.prototype.fit=function(){return this.enabled&&(this._fit(),this._center(),this._trigger("fit"))},i.prototype.zoomIn=function(){return this.enabled&&(this._zoom(this.zoomInFactor),this._trigger("zoomIn"))},i.prototype.zoomOut=function(){return this.enabled&&(this._zoom(this.zoomOutFactor),this._trigger("zoomOut"))},i.prototype.zoomCustom=function(t){return this.enabled&&(this._zoomScale(t),this._trigger("zoomCustom"))},i.prototype.getData=function(){return this.data},i.prototype.enable=function(){return this.enabled=!0},i.prototype.disable=function(){return this.enabled=!1},i.prototype.remove=function(){return this._unbind(),this._unwrap(),this.disable(),this.$el.off(s.start,this._start),this.$el.removeData(r+"Instance")},i}(),p=["rotateLeft","rotateRight","center","fit","zoomIn","zoomOut","zoomCustom","instance","getData","enable","disable","remove"],t.fn[r]=function(e,h){return"string"!=typeof e?this.each(function(){var h;return t.data(this,r+"Instance")?void 0:(h=new i(this,e),t.data(this,r+"Instance",h))}):c.call(p,e)<0?void 0:"instance"===e?t.data(this[0],r+"Instance"):"getData"===e?t.data(this[0],r+"Instance")[e]():this.each(function(){var i;return i=t.data(this,r+"Instance"),i?i[e](h):void 0})}}).call(this);

/*
A simple jQuery function that can add listeners on attribute change.
http://meetselva.github.io/attrchange/
About License:
Copyright (C) 2013-2014 Selvakumar Arumugam
You may use attrchange plugin under the terms of the MIT Licese.
https://github.com/meetselva/attrchange/blob/master/MIT-License.txt
  */
!function(t){var a=window.MutationObserver||window.WebKitMutationObserver;t.fn.attrchange=function(e,n){if("object"==typeof e){var r={trackValues:!1,callback:t.noop};if("function"==typeof e?r.callback=e:t.extend(r,e),r.trackValues&&this.each(function(a,e){for(var n,r={},i=(a=0,e.attributes),c=i.length;a<c;a++)r[(n=i.item(a)).nodeName]=n.value;t(this).data("attr-old-value",r)}),a){var i={subtree:!1,attributes:!0,attributeOldValue:r.trackValues},c=new a(function(a){a.forEach(function(a){var e=a.target;r.trackValues&&(a.newValue=t(e).attr(a.attributeName)),"connected"===t(e).data("attrchange-status")&&r.callback.call(e,a)})});return this.data("attrchange-method","Mutation Observer").data("attrchange-status","connected").data("attrchange-obs",c).each(function(){c.observe(this,i)})}return function(){var t=document.createElement("p"),a=!1;if(t.addEventListener)t.addEventListener("DOMAttrModified",function(){a=!0},!1);else{if(!t.attachEvent)return!1;t.attachEvent("onDOMAttrModified",function(){a=!0})}return t.setAttribute("id","target"),a}()?this.data("attrchange-method","DOMAttrModified").data("attrchange-status","connected").on("DOMAttrModified",function(a){a.originalEvent&&(a=a.originalEvent),a.attributeName=a.attrName,a.oldValue=a.prevValue,"connected"===t(this).data("attrchange-status")&&r.callback.call(this,a)}):"onpropertychange"in document.body?this.data("attrchange-method","propertychange").data("attrchange-status","connected").on("propertychange",function(a){a.attributeName=window.event.propertyName,function(a,e){if(a){var n=this.data("attr-old-value");if(e.attributeName.indexOf("style")>=0){n.style||(n.style={});var r=e.attributeName.split(".");e.attributeName=r[0],e.oldValue=n.style[r[1]],e.newValue=r[1]+":"+this.prop("style")[t.camelCase(r[1])],n.style[r[1]]=e.newValue}else e.oldValue=n[e.attributeName],e.newValue=this.attr(e.attributeName),n[e.attributeName]=e.newValue;this.data("attr-old-value",n)}}.call(t(this),r.trackValues,a),"connected"===t(this).data("attrchange-status")&&r.callback.call(this,a)}):this}if("string"==typeof e&&t.fn.attrchange.hasOwnProperty("extensions")&&t.fn.attrchange.extensions.hasOwnProperty(e))return t.fn.attrchange.extensions[e].call(this,n)}}(jQuery);


/*============================================================================
  #Builder JS
==============================================================================*/
$(document).ready(function() {
  builder();
});

function builder() {
  // =============================================
  // Select Product
  // =============================================
  $('.builder__step--product .builder__option').click(function() {
    if ($('.builder').hasClass('builder--has-edging')) {
      checkProgressEdging();
    } else {
      checkProgress();
    }

    // Update selection
    $('.builder__step-footer-category').text($(this).data('title'));
    $('.builder__step-footer-layout').text('');
    $('.builder__step-footer-size').text('');
    $('.builder__step-footer-edge').text('');

    // Update image
    $('.builder__step--product .builder__step-image').attr('src', $(this).data('image'));

    // Update continue button
    $('.builder__step--product .builder__step-submit').text($('.builder__step--product .builder__step-submit').data('continue-text'));
    $('.builder__step--product .builder__step-submit').removeAttr('disabled');

    // Focus continue button
    $('.builder__step--product .builder__step-submit').focus();

    // Add option selected class
    $('.builder__step--product').addClass('option-selected');

    // Update step count
    $('.builder__step-count-total').text($(this).data('step-count'));

    // Get collection handle
    var collectionHandle = $(this).data('collection');

    // Update active classes, if canvas skip layout step
    if (collectionHandle == 'canvas-prints' && $('.builder').hasClass('builder--canvas-prints') || collectionHandle == 'framed-prints' || collectionHandle == 'calendars') {
      $('.builder__step--product').removeClass('active');
      $('.builder__step--size').addClass('active');
      $('.builder__step--layout').addClass('small--hide');
    } else {
      $('.builder__step--product').removeClass('active');
      $('.builder__step--layout').addClass('active');
      $('.builder__step--layout').removeClass('small--hide');
    }

    if (collectionHandle == 'framed-prints' || collectionHandle == 'canvas-prints') {
      $('.builder__step--layout').addClass('hide');
    } else {
      $('.builder__step--layout').removeClass('hide');
    }

    // Add active class
    $('.builder__step--product .builder__option').removeClass('active');
    $(this).addClass('active');

    // Update type line item property
    $('.builder__line-type').val(collectionHandle);

    // Update summary
    $('.builder__summary-details-product').removeClass('hide');
    $('.builder__summary-change--product').removeClass('hide');

    // Show relative collection
    $('.builder__collection').addClass('hide');
    $('.builder__collection[data-collection='+collectionHandle+']').removeClass('hide');

    // Update progress bar
    updateProgressBar($('.builder__step--product'));
  });

  // =============================================
  // Submit Product
  // =============================================
  $('.builder__step--product .builder__step-submit').click(function() {
    if ($(this).parents('.builder__step').find('.builder__option.active').length) {
      var hrefAttribute = $('.builder__step--product .builder__option.active').attr('data-link');
      
      // If product has link go to product, else go to layout step
      if (hrefAttribute) {
        window.location.href = hrefAttribute;
      } else {
        $('.builder__step--layout .builder__option').removeClass('active');
        $('.builder__step--layout').addClass('visible active');
        $('.builder__step--product').removeClass('visible active');
        updateProgressBar($('.builder__step--layout'));
      }

      // Pushing category event in GA4
      gtag('event', 'builder_selected_product_category', {
        'selected_product_category': `${$(this).closest('.builder__content-column').find('.builder__option.active').data('title')}`
      });
      
    } else {
      alert(window.theme.builder.selectionError);
    }
  });

  // Update progress bar based on defined parent step
  function updateProgressBar(parent) {
    var stepValue = $(parent).find('.builder__step-value').text();
    var stepTotal = $(parent).find('.builder__step-count-total').text();
    var progressBarWidth = (stepValue / stepTotal) * 100;
    $('.builder__step-count-bar-inner').css('width', `${progressBarWidth}%`);
  }

  // =============================================
  // Select Layout
  // =============================================
  $('.builder__step--layout .builder__option').click(function() {
    $('.builder__step--layout .builder__step-image').attr('src', $(this).data('image'));
    $('.builder__step--layout .builder__option').removeClass('active');
    $('.builder__step-footer-layout').html(`, ${$(this).data('title')}`);
    $(this).addClass('active');

    // Update continue button
    $('.builder__step--layout .builder__step-submit').text($('.builder__step--layout .builder__step-submit').data('continue-text'));
    $('.builder__step--layout .builder__step-submit').removeAttr('disabled');

    // Focus continue button
    $('.builder__step--layout .builder__step-submit').focus();
  });

  // =============================================
  // Submit Layout
  // =============================================
  $('.builder__step--layout .builder__step-submit').click(function() {
    if ($(this).parents('.builder__step').find('.builder__option.active').length) {
      
      window.location.href = $('.builder__step--layout .builder__option.active').attr('data-link');

      // Pushing product event in GA4
      gtag('event', 'builder_selected_product', {
        'selected_product': `${$(this).closest('.builder__content-column').find('.builder__option.active').data('title')}`
      });
      
    } else {
      alert(window.theme.builder.selectionError);
    }
  });

  // =============================================
  // Select Size
  // =============================================
  $('.builder__step--size .builder__option').click(function() {
    // Update active class
    $('.builder__step--size .builder__option').removeClass('active');
    $(this).addClass('active');

    // Update footer size
    $('.builder__step-footer-size').html(`, ${$(this).data('title')}`);

    // Update continue button
    $('.builder__step--size .builder__step-submit').text($('.builder__step--size .builder__step-submit').data('continue-text'));
    $('.builder__step--size .builder__step-submit').removeAttr('disabled');

    // Focus continue button
    $('.builder__step--size .builder__step-submit').focus();

    if($('.builder').hasClass('mediaclip')) {
      // Get variant details
      var variant = $(this).data('variant');
      var variantHandle = $(this).data('variant-handle');
      var variantPrice = $(this).data('variant-price');
      var variantImage = $(this).data('variant-image');
      var aspectRatio = $(this).data('aspect-ratio');

      // Update size line item property
      $('.builder__line-size').val(variantHandle);

      // Update selected variant
      $('.builder__mediaclip-select').val(variant).trigger('change');
    } else {
      if ($('.builder').hasClass('builder--has-edging')) {
        checkProgressEdging();
      } else {
        checkProgress();
      }

      // Add option selected class
      $('.builder__step--size').addClass('option-selected');

      // Update image
      if ($(this).data('image')) {
        $('.builder__step--size .builder__step-image').attr('src', $(this).data('image'));
      }

      // Get variant details
      var variant = $(this).data('variant');
      var variantHandle = $(this).data('variant-handle');
      var variantPrice = $(this).data('variant-price');
      var variantComparePrice = $(this).data('variant-compare-price');
      var variantImage = $(this).data('variant-image');
      var aspectRatio = $(this).data('aspect-ratio');

      // Add aspect ratio class for panormaa / double width
      if (aspectRatio == 'panorama' || aspectRatio == 'panorama-ratio-4-1-or-3-1' || aspectRatio == 'panorama-3-1') {
        $('.builder__preview').addClass('panorama-print');
        $('.builder__step--frame').addClass('panorama');
        $('.builder__preview-popup').addClass('panorama');
      } else {
        $('.builder__preview').removeClass('panorama-print');
        $('.builder__step--frame').removeClass('panorama');
        $('.builder__preview-popup').removeClass('panorama');
      }

      if (aspectRatio == 'double-width-2-1' || aspectRatio == 'double-ratio-2-1') {
        $('.builder__preview').addClass('double-width-print');
      } else {
        $('.builder__preview').removeClass('double-width-print');
      }

      if (aspectRatio == 'square-ratio-1-1' || aspectRatio == 'square') {
        $('.builder__step--frame').addClass('square');
        $('.builder__preview-popup').addClass('square');
      } else {
        $('.builder__step--frame').removeClass('square');
        $('.builder__preview-popup').removeClass('square');
      }

      // Update active classes
      $('.builder__step--size').removeClass('active');

      if ($('.template-builder').hasClass('event-ready')) {
        if ($('.builder').hasClass('builder--has-edging')) {
          $('.builder__step--edge').addClass('active');
        } else {
          $('.builder__step--upload').addClass('active');
        }
      }

      // Update summary class
      $('.builder__summary-details-size').text(variant + ' ' + variantPrice);
      $('.builder__summary').addClass('active');

      // Set variant id
      $('[data-product-select]').val(variant).change();

      // Update size line item property
      $('.builder__line-size').val(variantHandle);

      // Update summary
      $('.builder__subtotal-value').text(variantPrice);
      $('.product-price').text(variantPrice);
      $('.compare-price').text(variantComparePrice);
      $('.builder__summary-details-size').text($(this).data('title'));
      $('.builder__summary-image').attr('src',variantImage);
      $('.builder__summary-change--size').removeClass('hide');

      if (!variantComparePrice || variantComparePrice === variantPrice) {
        $('.compare-price').hide();
      } else {
        $('.compare-price').show();
      }

      // Add active class
      $('.builder__step--size .builder__option').removeClass('active');
      $('.builder__step--size .builder__option[data-variant-handle='+variantHandle+']').addClass('active');

      // Update selected variant
      $('.single-option-selector').val(variant).trigger('change');

      // Reset active class
      $('.builder__option--frame').removeClass('active');

      // Choose frameless by default
      $('.builder__option--frameless').trigger('click');

      // If product has frames
      if ($('.builder__step').hasClass('builder__step--frame') && !$('.builder__step').hasClass('builder__step--frame-preview') && !$('.builder').hasClass('builder--gallery-box')) {

        // If no frame update selection to no frame
        if ($(this).hasClass('no-frame')) {
          $('.builder__option--frameless').trigger('click');
          $('.builder__summary-details-frame-price').text('$0.00');
          $('.builder__summary-details-frame-wrap').hide();
          $('.builder__step--frame').addClass('hide');
          $('.builder__upload-submit').hide();
          if (!$(this).closest('.builder--framed-prints').length) {
            $('.builder__step--summary .builder__summary-change--frame').attr('data-section', 'builder-upload');
            $('.builder__step--upload .builder__summary-change--frame').attr('data-section', 'builder-summary');
            $('.builder__step-count-total').text($('.builder__step-count-total').attr('data-step-count-minus'));
            $('.builder__step--summary .builder__step-value').text($('.builder__step--summary .builder__step-value').attr('data-step-count-minus'));
          }
          $('.builder__step--frame').removeClass('visible');
          $('.framing-preview').removeClass('frame-selected');
        } else {
          $('.builder__option--frameless').removeClass('active');
          $('.builder__summary-details-frame-price').text('$0.00');
          $('.builder__summary-details-frame-wrap').show();
          $('.builder__step-count-total').text($('.builder__step-count-total').attr('data-step-count-original'));
          $('.builder__step--summary .builder__step-value').text($('.builder__step--summary .builder__step-value').attr('data-step-count-original'));

          if ($('.builder__preview').hasClass('active')) {
            $('.builder__step--frame').removeClass('hide');
          }

          $('.builder__step--frame').removeClass('hide');
          $('.builder__upload-submit').show();

          if (!$(this).closest('.builder--framed-prints').length) {
            $('.builder__step--summary .builder__summary-change--frame').attr('data-section', 'builder-frame');
            $('.builder__step--upload .builder__summary-change--frame').attr('data-section', 'builder-frame');
          }

          // Update frames to match selected variant
          $('.builder__option--frame').each(function() {
            var newPrice = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-price');
            var newID = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-id');
            $(this).attr('data-frame-price', newPrice);
            $(this).attr('data-frame-id', newID);
            if (!newPrice) {
              $(this).hide();
            } else {
              $(this).show();
              $(this).find('[data-listed-frame-price]').text('$'+newPrice);
            }
          });

          // Check for undefined
          $('.builder__option--frame').each(function() {
            var variantTitle = $(this).find('p').text();
            if (variantTitle == '$undefined') {
              $(this).parents('.grid__item').addClass('hide');

              if($(this).hasClass('builder__option--frame active')) {
                $('.builder__summary-details-frame-price').text('$0.00');
              }
            } else {
              $(this).parents('.grid__item').removeClass('hide');
            }
          });

          // Update price if frame is selected
          setTimeout(function() {
            var framePrice = $('.builder__summary-details-frame-price').text();
            var productPrice = $('.builder__summary-price.product-price').text().replace('$','');
            var framePriceRaw = framePrice.replace('$','');
            var updatedPrice = parseFloat(productPrice) + parseFloat(framePriceRaw);
            $('.builder__subtotal-value').text('$' + updatedPrice.toFixed(2));

            if (updatedPrice > 150) {
              $('.builder__summary-free-shipping').removeClass('hide');
            } else {
              $('.builder__summary-free-shipping').addClass('hide');
            }

            $('.builder__option--frame.active').click();
            $('.builder__option--frameless.active').click();
          }, 200);
        }
      }

      // If we're on gallery box, always show the frame step
      if ($('.builder').hasClass('builder--gallery-box')) {
        if ($('.builder__preview').hasClass('active')) {
          $('.builder__step--frame').addClass('visible');
          $('.builder__step--frame').removeClass('hide');
        }

        $('.builder__step--frame').removeClass('hide');
        $('.builder__upload-submit').show();
        $('.builder__step--summary .builder__summary-change--frame').attr('data-section', 'builder-frame');
        $('.builder__step--upload .builder__summary-change--frame').attr('data-section', 'builder-frame');

        // Update frames to match selected variant
        $('.builder__option--frame').each(function() {
          var newPrice = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-price');
          var newID = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-id');
          $(this).attr('data-frame-price', newPrice);
          $(this).attr('data-frame-id', newID);

          if (!newPrice) {
            $(this).hide();
          } else {
            $(this).show();
            $(this).find('[data-listed-frame-price]').text('+ $'+newPrice);
          }
        });

        // Check for undefined
        $('.builder__option--frame').each(function() {
          var variantTitle = $(this).find('p').text();
          if (variantTitle == '$undefined') {
            $(this).parents('.grid__item').addClass('hide');

            if($(this).hasClass('builder__option--frame active')) {
              $('.builder__summary-details-frame-price').text('$0.00');
            }
          } else {
            $(this).parents('.grid__item').removeClass('hide');
          }
        });
      }

      // Show next step if builder has frame step
      if (!$('.builder__step').hasClass('builder__step--frame')) {
        $('.builder__upload-submit').hide();
      }

      if ($('.builder__step').hasClass('builder__step--frame-preview')) {
        // If no frame update selection to no frame
        if ($(this).hasClass('no-frame')) {
          $('.builder__option--frameless').trigger('click');
          $('.builder__summary-details-frame-price').text('$0.00');
          $('.builder__summary-details-frame-wrap').hide();
          $('.builder__step--frame').addClass('hide');
          $('.builder__upload-submit').hide();

          if (!$(this).closest('.builder--framed-prints').length) {
            $('.builder__step--summary .builder__summary-change--frame').attr('data-section', 'builder-upload');
            $('.builder__step--upload .builder__summary-change--frame').attr('data-section', 'builder-summary');
            $('.builder__step-count-total').text($('.builder__step-count-total').attr('data-step-count-minus'));
            $('.builder__step--summary .builder__step-value').text($('.builder__step--summary .builder__step-value').attr('data-step-count-minus'));
          }

          $('.framing-preview').removeClass('frame-selected');
        } else {
          $('.builder__option--frameless').removeClass('active');
          $('.builder__summary-details-frame-price').text('$0.00');
          $('.builder__summary-details-frame-wrap').show();
          $('.builder__step-count-total').text($('.builder__step-count-total').attr('data-step-count-original'));
          $('.builder__step--summary .builder__step-value').text($('.builder__step--summary .builder__step-value').attr('data-step-count-original'));

          if ($('.builder__preview').hasClass('active')) {
            $('.builder__step--frame').removeClass('hide');
          }

          $('.builder__step--frame').removeClass('hide');
          $('.builder__upload-submit').show();

          if (!$(this).closest('.builder--framed-prints').length) {
            $('.builder__step--summary .builder__summary-change--frame').attr('data-section', 'builder-frame');
            $('.builder__step--upload .builder__summary-change--frame').attr('data-section', 'builder-frame');
          }
        }

        // Update frames to match selected variant
        $('.builder__option--frame').each(function() {
          var newPrice = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-price');
          var newID = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-id');
          var newVariantImage = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-image');
          var newVariantTitle = $(this).find('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-title');

          if (newPrice === undefined) {
            if (!$('.builder').hasClass('builder--framed-prints') || !$('.builder').hasClass('builder--gallery-box')) {
              $('.builder__option--frameless').click();
              $('.builder__step--frame').addClass('hide');
              $('.builder__summary-details-frame-wrap').addClass('hide');
              $('.builder__upload-submit').hide();
            }
            
            $(this).hide();
          } else {
            $(this).show();
            $('.builder__step--frame').removeClass('hide');
            $('.builder__summary-details-frame-wrap').removeClass('hide');
            $('.builder__upload-submit').show();
            $(this).attr('data-frame-price', newPrice);
            $(this).attr('data-frame-id', newID);
            $(this).find('[data-listed-frame-price]').text('+ $'+newPrice);
            $(this).find('.builder__frame-variant').text(newVariantTitle);
            $(this).find('.builder__frame-wrap').attr('src',newVariantImage);
          }
        });

        // Check for undefined
        $('.builder__option--frame').each(function() {
          var variantTitle = $(this).find('p').text();
          if (variantTitle == '$undefined') {
            $(this).parents('.grid__item').addClass('hide');

            if($(this).hasClass('builder__option--frame active')) {
              $('.builder__summary-details-frame-price').text('$0.00');
            }
          } else {
            $(this).parents('.grid__item').removeClass('hide');
          }
        });

        // Update preview frame
        var activeFrameImage = $('.builder__option--frame.active .builder__frame-wrap').attr('src');
        var activeFrameTitle = $('.builder__option--frame.active h4').text();

        if (activeFrameTitle != 'No Frame') {
          $('.framing-preview').addClass('frame-selected');
          $('.framing-preview .frame-wrap').attr('src',activeFrameImage);
        } else {
          $('.framing-preview').removeClass('frame-selected');
        }

        if(!$('.builder__option--frame').hasClass('active')) {
          $('.framing-preview').removeClass('frame-selected');
        }

        setTimeout(function() {
          $('.builder__option--frame.active').click();
          $('.builder__option--frameless.active').click();
        }, 200);
      }

      // Re-init builderCanvas if template is event ready
      if ($('.template-builder').hasClass('event-ready')) {
        $('.builder__preview-column').fadeTo('fast', 0);
        $('.builder__preview-main-image').guillotine('remove');

        // If two panel canvas
        if ($('.builder').hasClass('builder--two-panel-canvas')) {
          $('.builder__preview-main-image-2').guillotine('remove');
        }

        // If three panel canvas
        if ($('.builder').hasClass('builder--three-panel-canvas')) {
          $('.builder__preview-main-image-2').guillotine('remove');
          $('.builder__preview-main-image-3').guillotine('remove');
        }

        // Add class indicating size has changed post upload
        if ($('.builder__preview').hasClass('active')) {
          $('.builder').addClass('size-changed');
        }

        setTimeout(function() {
          builderCanvas();
        }, 250);

        setTimeout(function() {
          $('.builder__preview-main-image').guillotine('center');
          $('.builder__preview-main-image').guillotine('fit');

          // If two panel canvas
          if ($('.builder').hasClass('builder--two-panel-canvas')) {
            $('.builder__preview-main-image-2').guillotine('center');
            $('.builder__preview-main-image-2').guillotine('fit');
          }

          // If three panel canvas
          if ($('.builder').hasClass('builder--three-panel-canvas')) {
            $('.builder__preview-main-image-2').guillotine('center');
            $('.builder__preview-main-image-2').guillotine('fit');
            $('.builder__preview-main-image-3').guillotine('center');
            $('.builder__preview-main-image-3').guillotine('fit');
          }

          // forceAttrChange
          forceAttrChange();

          // Fade in
          $('.builder__preview-column').fadeTo('fast', 1);

          // Check quality
          checkQuality();
        }, 400);
      }

      // Hide warning while section reloads
      $('.builder__preview-warning').addClass('hide');

      setTimeout(function() {
        $('.builder__preview-warning').removeClass('hide');
      }, 1500);

      // Scroll to next section
      if ($('.template-builder').hasClass('event-ready')) {
        if ($(window).width() >= 750) {
          if ($('.builder').hasClass('builder--has-edging')) {
            $('html, body').animate({
              scrollTop: ($('#builder-edge').offset().top - 50)
            }, 300);
          } else {
            $('html, body').animate({
              scrollTop: ($('#builder-upload').offset().top - 50)
            }, 300);
          }
        }
      }
    }
  });

  // =============================================
  // Submit Size
  // =============================================
  $('.builder__step--size .builder__step-submit').click(function() {
    if ($(this).parents('.builder__step').find('.builder__option.active').length || $(this).parents('.builder__step').find('.builder__select').length) {
     
      if ($('.builder').hasClass('mediaclip')) {
        $('.btn--mediaclip').click();
      } else {
        $('.builder__step--size').removeClass('visible active');

        if ($('.builder__step--edge').length) {
          $('.builder__step--edge').addClass('visible active');
        } else {
          $('.builder__step--upload').addClass('visible active');
          builderCanvas();
        }
      }
      
      // Pushing size event in GA4
      gtag('event', 'builder_selected_size', {
      'selected_size': `${$(this).closest('.builder__content-column').find('.builder__option.active').data('title')}`
      });
      
    } else {
      alert(window.theme.builder.selectionError);
    }
  });

  // Toggle aspect ratios
  $('.builder__select--aspect-ratio').change(function() {
    $('.product-single__pricing-ratio').addClass('hide');
    $(`.product-single__pricing-ratio-${$(this).val()}`).removeClass('hide');
  });

  // Update prices
  $('.builder__step--size .builder__option').each(function() {
    var variantHandle = $(this).data('variant-handle');
    var variantPrice = parseFloat($(this).data('variant-price').replace('$',''));
    var framePrice = parseFloat($('.frame-variant[data-variant-handle='+variantHandle+']').data('variant-price'));
    var withFramePrice = variantPrice + framePrice;

    if (framePrice) {
      $(this).find('.frame-price').text('$'+withFramePrice.toFixed(2));
      $(this).find('.icon-frame').removeClass('hide');
    } else {
      $(this).find('.frame-price').text('-');
      $(this).addClass('no-frame');
    }
  });

  // Select options
  $('.builder__step--size .builder__step-selector select').change(function() {
    var option1Value = ''
    var option2Value = ''
    var option3Value = ''

    if($('.builder__step-selector').hasClass('builder__step-selector--1')) {
      option1Value = $('.builder__step-selector--1 select').val();
    }

    if($('.builder__step-selector').hasClass('builder__step-selector--2')) {
      option2Value = $('.builder__step-selector--2 select').val();
    }

    if($('.builder__step-selector').hasClass('builder__step-selector--3')) {
      option3Value = $('.builder__step-selector--3 select').val();
    }

    $('.builder__mediaclip-select > option').each(function(option) {
      if ($(this).text().indexOf(option1Value) >= 0 && $(this).text().indexOf(option2Value) >= 0 && $(this).text().indexOf(option3Value) >= 0) {
        $('.builder__mediaclip-select').val($(this).val()).trigger('change');
      }
    });

    // Update continue button
    $('.builder__step--size .builder__step-submit').text($('.builder__step--size .builder__step-submit').data('continue-text'));
    $('.builder__step--size .builder__step-submit').removeAttr('disabled');
  });

  // =============================================
  // Select Edge
  // =============================================
  $('.builder__step--edge .builder__option').click(function() {
    if ($('.builder').hasClass('builder--has-edging')) {
      checkProgressEdging();
    } else {
      checkProgress();
    }

    // Add option selected class
    $('.builder__step--edge').addClass('option-selected');

    // Update footer edge
    $('.builder__step-footer-edge').html(`, ${$(this).data('title')}`);

    // Update continue button
    $('.builder__step--edge .builder__step-submit').text($('.builder__step--edge .builder__step-submit').data('continue-text'));
    $('.builder__step--edge .builder__step-submit').removeAttr('disabled');

    // Focus continue button
    $('.builder__step--edge .builder__step-submit').focus();

    // Update image
    $('.builder__step--edge .builder__step-image').attr('src', $(this).data('image'));

    // Get edge
    var edge = $(this).data('edge');

    if (edge == 'mirrored' || edge == 'wrapped') {
      // Update active classes
      $('.builder__step--edge').removeClass('active');
      $('.builder__step--upload').addClass('active');
    }

    // If edge option is not already active
    if (!$(this).hasClass('active')) {
      $('.builder__step--edge .builder__option').removeClass('active');
      $(this).addClass('active');

      // Add disabled class to color picker button
      $('.builder__color-picker').addClass('disabled');

      // Update edge line item property
      $('.builder__line-edge').val(edge);

      // Update summary
      $('.builder__summary-details-edge').text(edge);
      $('.builder__summary-change--edge').removeClass('hide');

      // If edge is mirrored
      if (edge == 'mirrored') {
        $('.builder__preview-top-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap, .builder__preview-right-wrap').css('background', '');
        $('.builder__preview').addClass('mirrored');
        $('.zoom-range')[0].value = $('.zoom-range').attr('min');
      } else {
        $('.builder__preview').removeClass('mirrored');
      }

      // If edge is wrapped
      if (edge == 'wrapped') {
        $('.builder__preview').addClass('wrapped');

        $('.builder__preview-top-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap, .builder__preview-right-wrap').css('background', '');

        // Go to top on mobile
        if ($(window).width() < 750) {
          $('html, body').scrollTop(0);
        }

        // Add class for preview popup
        $('.builder__preview-popup').addClass('wrapped');
      } else {
        $('.builder__preview').removeClass('wrapped');
        $('.builder__preview-popup').removeClass('wrapped');
      }

      // If edge is colored
      if (edge == 'coloured') {
        // Focus color picker button
        $('.builder__color-picker').focus();

        $('.builder__preview').addClass('coloured');
        if ($('.builder__line-edge-color').val() != '') {
          var edgeColor = $('.builder__line-edge-color').val();
          $('.builder__preview-top-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap, .builder__preview-right-wrap').css('background', edgeColor);
        } else {
          $('.builder__line-edge-color').val('#000000');
          $('.builder__preview-top-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap, .builder__preview-right-wrap').css('background', '#000000');
        }
      } else {
        $('.builder__preview').removeClass('coloured');
      }
    }

    // Trigger change for mobile resizing
    $('.zoom-in-button').click();
    $('.zoom-out-button').click();

    // Scroll to next section
    if ($('.template-builder').hasClass('event-ready')) {
      if (edge == 'mirrored' || edge == 'wrapped') {
        if ($(window).width() >= 750) {
          $('html, body').animate({
            scrollTop: ($('#builder-upload').offset().top - 50)
          }, 300);
        }
      }
    }
  });

  // =============================================
  // Submit Edge
  // =============================================
  $('.builder__step--edge .builder__step-submit').click(function() {
    if ($(this).parents('.builder__step').find('.builder__option.active').length) {
      $('.builder__step--edge').removeClass('visible active');
      $('.builder__step--upload').addClass('visible active');
      builderCanvas();
    } else {
      alert(window.theme.builder.selectionError);
    }
  });

  // =============================================
  // Color Picker
  // =============================================
  $('.builder__color-picker').spectrum({
    color: "#000000",
    preferredFormat: "hex",
    showInput: true
  });

  // Color picker button
  $('.builder__color-picker').click(function() {
    $('.builder__image-edge').css('background','#000000');
    $('.builder__line-edge-color').val('#000000');
    $('.builder__line-edge').val('coloured');
    $('.builder__step--edge .builder__option').removeClass('active');
    $('.builder__step--edge .builder__option--stacked--color').addClass('active');
    $(this).removeClass('disabled');
    $('.builder__preview').addClass('coloured');

    // Focus color picker input
    $('.sp-input').focus();
  });

  // Update edge color when user selects color
  $('.sp-choose, .sp-color').click(function() {
    if ($('.builder__line-edge').val() == 'coloured') {
      var edgeColor = '#' + $('.builder__color-picker').spectrum('get').toHex();
      $('.builder__preview-top-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap, .builder__preview-right-wrap').css('background', edgeColor);
      $('.builder__line-edge-color').val(edgeColor);
      $('.builder__color-picker').css('background-color', edgeColor);

      // Update continue button
      $('.builder__step--edge .builder__step-submit').text($('.builder__step--edge .builder__step-submit').data('continue-text'));
      $('.builder__step--edge .builder__step-submit').removeAttr('disabled');

      // Focus continue button
      $('.builder__step--edge .builder__step-submit').focus();
    }
  });

  // Update active classes when user clicks choose button
  $('.sp-choose').click(function() {
    // Add option selected class
    $('.builder__step--edge').addClass('option-selected');
  });

  // =============================================
  // Upload Photo
  // =============================================
  UPLOADCARE_PUBLIC_KEY = '816a2bce191cf6135c71';
  UPLOADCARE_LOCALE = window.location.href.indexOf('/fr/') >= 0 ? 'fr' : '';
  uploadcare.registerTab('preview', uploadcareTabEffects);
  var singleWidget = uploadcare.SingleWidget('[role=uploadcare-uploader]');

  $('.builder__upload-photo').click(function() {
    var pictureWidth = $('.builder__step--size .builder__option.active').data('width');
    var pictureHeight = $('.builder__step--size .builder__option.active').data('height');

    if (pictureWidth === 11 && pictureHeight === 85) {
      pictureWidth = 22;
      pictureHeight = 17;
    }

    var dialog = singleWidget.openDialog({
      crop: `${pictureWidth}:${pictureHeight},${pictureHeight}:${pictureWidth}`
    });

    dialog.fileColl.onAdd.add(file => {
      file.progress(progressInfo => {
        if (progressInfo.state !== 'ready') { return; }

        setTimeout(() => {
          $('.uploadcare--button[aria-label="Crop"]').trigger('click');
          $('.uploadcare--button[aria-label="Recadrer"]').trigger('click');
        }, 1000);
      });
    });

    if ($('.builder').hasClass('size-changed')) {
      setTimeout(() => {
        $('.uploadcare--button[aria-label="Crop"]').trigger('click');
        $('.uploadcare--button[aria-label="Recadrer"]').trigger('click');

        setTimeout(() => {
          $('.uploadcare--crop-sizes__item:last-child').trigger('click');
          $('.uploadcare--crop-sizes__item:first-child').trigger('click');
          $('.builder').removeClass('size-changed');
        }, 500);
      }, 500);
    }
  });

  singleWidget.onChange(function(file) {
    if (file) {
      file.done(function(data) {
        $('.builder__preview-pre-upload').addClass('hide');
        $('.builder__loading').removeClass('hide');
        $('.builder__preview-column').fadeTo('fast', 0);
        $('.builder__preview').removeClass('active');
        $('.builder__upload-photo').addClass('hide');
        $('.icon-upload').addClass('hide');
        $('.builder__preview-main-section, .builder__preview-sidebar').css('opacity','0');
        $('.builder__upload-step-1').addClass('hide');
        $('.builder__upload-step-2').removeClass('hide');

        // Append uploadcare handle line item property
        $('.builder__line-uploadcare-handle').val(data.cdnUrl);
        $('.builder__line-uploadcare-original-image').val(data.originalUrl);

        // Update continue button
        $('.builder__step--upload .builder__step-submit').text($('.builder__step--upload .builder__step-submit').data('continue-text'));
        $('.builder__step--upload .builder__step-submit').removeAttr('disabled');

        // Focus continue button
        $('.builder__step--upload .builder__step-submit').focus();

        // Show buttons
        $('.builder__upload-block-content').removeClass('hide');

        // Update images with new image url
        var fileUrlProcessed = data.cdnUrl;

        if (fileUrlProcessed.indexOf('/enhance/') >= 0 && data.cdnUrl.indexOf('-/preview/5000x5000/') === -1) {
          fileUrlProcessed = data.cdnUrl.replace('-/preview/','-/preview/5000x5000/')
        } else if (fileUrlProcessed.indexOf('/enhance/') === -1) {
          fileUrlProcessed = data.cdnUrl.replace('-/preview/5000x5000/','').replace('-/preview/','');
        }

        $('.builder__preview-main-image').attr('data-original-height',data.originalImageInfo.height);
        $('.builder__preview-main-image').attr('data-original-width',data.originalImageInfo.width);
        $('.builder__preview-main-image').attr('data-crop-height',data.crop.height);
        $('.builder__preview-main-image').attr('data-crop-width',data.crop.width);  
        $('.builder__preview-main-image').attr('src',data.cdnUrl);
        $('.builder__preview-main-image-2').attr('src',data.cdnUrl);
        $('.builder__preview-main-image-3').attr('src',data.cdnUrl);
        $('.builder__preview-image').data('image',data.cdnUrl);
        $('.builder__preview-image').attr('src',data.cdnUrl);
        $('.builder__line-image').val(`${fileUrlProcessed.indexOf('-/format/jpg/') === -1 ? `${fileUrlProcessed}-/format/jpg/` : fileUrlProcessed}`);

        var image = $('.builder__preview-main-image');

        image.on('load', function() {
          imageUploaded();
        });

        function imageUploaded() {
          // Determine if we should flip image
          setTimeout(function() {
            var screenImage = $(".builder__preview-main-image");
            var theImage = new Image();
            theImage.src = screenImage.attr("src");
            var naturalImageWidth = theImage.width;
            var naturalImageHeight = theImage.height;

            if(!$('.builder').hasClass('builder--two-panel-canvas') && !$('.builder').hasClass('builder--three-panel-canvas')) {
              if (naturalImageHeight > naturalImageWidth) {
                $('.builder__preview').addClass('flipped');
                $('.builder__preview-popup').addClass('flipped');
                $('.builder__step--frame').addClass('flipped');
                $('.builder__line-orientation').val('flipped');
              } else {
                $('.builder__preview').removeClass('flipped');
                $('.builder__preview-popup').removeClass('flipped');
                $('.builder__step--frame').removeClass('flipped');
                $('.builder__line-orientation').val('');
              }
            }
          }, 1000);

          // Show preview section and hide upload button
          $('.builder__preview').addClass('active');

          // Check progress
          if ($('.builder').hasClass('builder--has-edging')) {
            checkProgressEdging();
          } else {
            checkProgress();
          }

          // Fade out and remove canvas
          $('.builder__preview-main-image').guillotine('remove');

          if ($('.builder').hasClass('builder--two-panel-canvas')) {
            $('.builder__preview-main-image-2').guillotine('remove');
          }

          if ($('.builder').hasClass('builder--three-panel-canvas')) {
            $('.builder__preview-main-image-2').guillotine('remove');
            $('.builder__preview-main-image-3').guillotine('remove');
          }

          // Reinitialize Canvas
          setTimeout(function() {
            builderCanvas();
          }, 1500);

          // Reposition and fade in canvas
          setTimeout(function() {
            $('.builder__preview-main-image').guillotine('center');
            $('.builder__preview-main-image').guillotine('fit');
            $('.builder__preview-column').fadeTo('fast', 1);
          }, 2000);

          // forceAttrChange if multi-panel canvas
          if ($('.builder').hasClass('builder--two-panel-canvas') || $('.builder').hasClass('builder--three-panel-canvas')) {
            setTimeout(function() {
              forceAttrChange();
            }, 3000);
          }

          // Show preview and sidebar
          setTimeout(function() {
            $('.builder__preview-main-section, .builder__preview-sidebar').css('opacity','1');
          }, 1500);

          // Check quality
          setTimeout(function() {
            checkQuality();
          }, 1500);

          // Hide loader
          $('.builder__loading').addClass('hide');
          $('.builder__preview').addClass('ready');

          // Hide zoom while section loads
          $('.builder__zoom-controls').addClass('hide');

          setTimeout(function() {
            $('.builder__zoom-controls').removeClass('hide');
          }, 2500);

          // Hide warning while section loads
          $('.builder__preview-warning').addClass('hide');

          setTimeout(function() {
            $('.builder__preview-warning').removeClass('hide');
          }, 2500);
        }

        // If framed product
        if ($('.builder__step').hasClass('builder__step--frame')) {

          // Update summary
          $('.builder__summary-change--upload').removeClass('hide');

          // Preselect users frame if there is one
          setTimeout(function() {
            if ($('.builder__step--size tr.builder__option.active').find('.frame-price').text() != '-') {
              var withFrame = $('.builder__step--frame').attr('data-frame');

              if (withFrame != '') {
                $('.builder__option--frame[data-frame-handle='+withFrame+']').click();
              }
            }

            if($('.builder').hasClass('builder--framed-prints') || $('.builder').hasClass('builder--gallery-box')) {
              var withFrame = $('.builder__step--frame').attr('data-frame');

              if (withFrame != '') {
                $('.builder__option--frame[data-frame-handle='+withFrame+']').click();
              }
            }
          }, 300);
        }

      });
    };
  });

  // =============================================
  // Submit Photo
  // =============================================
  $('.builder__step--upload .builder__step-submit').click(function() {
    if ($(this).parents('.builder__step').find('.builder__preview.active').length) {

      if ($('.builder__step--size .builder__option.active').hasClass('no-frame') && !$(this).closest('.builder--framed-prints').length && !$(this).closest('.builder--gallery-box').length) {
        $('.builder__step--summary').addClass('visible active');
        $('.builder__step--upload').removeClass('visible active');
      } else {
        $('.builder__step--frame').addClass('visible active');
        $('.builder__step--upload').removeClass('visible active');
      }

      // Pushing image_upload event in GA4
      gtag('event', 'builder_upload_image', {
      'upload_image': true
      });
      
    } else {
      alert(window.theme.builder.uploadError);
    }
  });

  // =============================================
  // Adjust Photo
  // =============================================
  $('.builder__preview-new-upload').click(function() {
    $('.builder__upload-photo').trigger('click');
    $('.uploadcare--menu__item_tab_file').trigger('click');
  });

  // =============================================
  // Photo Preview & State Rebuilding
  // =============================================
  $(window).load(function() {
    // Fade in page
    setTimeout(function() {
      $('.template-builder').addClass('active');
    }, 200);

    // Check for query strings so we can rebuild state
    if (window.location.href.indexOf('?') > 1) {
      // init getQueryStrings
      getQueryStrings();

      // Create variables for each querystring hash
      var type = getQueryStrings()['type'];
      var size = getQueryStrings()['_size'];
      var image = getQueryStrings()['_image'];
      var edge = getQueryStrings()['edge'];
      var edgeColor = getQueryStrings()['edge-color'];
      var frame = getQueryStrings()['_frame'];
      var scale = getQueryStrings()['_scale'];
      var x = getQueryStrings()['_x'];
      var y = getQueryStrings()['_y'];
      var orientation = getQueryStrings()['_orientation'];
      var filter = getQueryStrings()['image-filter'];
      var enhance = getQueryStrings()['image-enhance'];
      var id = getQueryStrings()['_id'];
      var scrollPosition = getQueryStrings()['scroll-position'];
      var emptyState = getQueryStrings()['empty-state'];
      var goTo = getQueryStrings()['go-to'];
      var withFrame = getQueryStrings()['with-frame'];
      var uploadCareHandle = getQueryStrings()['_uploadcare-handle'];
      var shopifyFile = getQueryStrings()['_shopify-file'];

      // If we have type
      if (type) {
        $('.builder__step--product .builder__option[data-collection='+type+']').click();
      }

      // If we have size
      if (size) {
        let sizeHandle = size;

        if (window.location.href.indexOf('/fr/') >= 0) {
          sizeHandle = size.replace('inches', 'pouces')
        }

        $('.builder__step--size .builder__option[data-variant-handle='+sizeHandle+']').click();
        $('.builder__step--layout').removeClass('visible');
        $('.builder__step--size').addClass('visible');
        $('.builder__step--layout').addClass('option-selected');
        $('.builder__step--size').addClass('option-selected');
        $('.builder__step--product .builder__option.active').click();
        $('.builder__step--layout .builder__option.active').click();

        setTimeout(function() {
          $('.builder__step--size .builder__option[data-variant-handle='+sizeHandle+']').click();

          // Update selected variant
          $('.single-option-selector').trigger('change');

          // Update price if frame is selected
          if ($('.builder__step').hasClass('builder__step--frame-standard')) {
            setTimeout(function() {
              var framePrice = $('.builder__summary-details-frame-price').text();
              var productPrice = $('.builder__summary-price.product-price').text().replace('$','');
              var framePriceRaw = framePrice.replace('$','');
              var updatedPrice = parseFloat(productPrice) + parseFloat(framePriceRaw);
              $('.builder__subtotal-value').text('$' + updatedPrice.toFixed(2));

              if (updatedPrice > 150) {
                $('.builder__summary-free-shipping').removeClass('hide');
              } else {
                $('.builder__summary-free-shipping').addClass('hide');
              }

              $('.builder__option--frame').each(function() {
                var variantId = $(this).data('frame-id');
                var variantImage = $('.frame-variant[data-variant-id="'+variantId+'"]').data('variant-image');
                $(this).find('.builder__frame-wrap').attr('src',variantImage);
              });
            }, 100);
          } else {
            setTimeout(function() {
              var productPrice = $('.builder__summary-price.product-price').text().replace('$','');
              var productPriceParsed = parseFloat(productPrice);

              if (productPriceParsed > 150) {
                $('.builder__summary-free-shipping').removeClass('hide');
              } else {
                $('.builder__summary-free-shipping').addClass('hide');
              }
            }, 100);
          }
        }, 100);

        if ($('.builder__step--size .builder__option--block').hasClass('active')) {
          $('.builder__aspect-ratios').addClass('hide');
        }
      }

      // If we have edge
      if (edge) {
        $('.builder__step--edge .builder__option[data-edge='+edge+']').click();
      }

      // If we have coloured edge
      if (edge == 'coloured') {
        if (edgeColor) {
          $('.builder__color-picker').spectrum('set',edgeColor);
          $('.builder__line-edge-color').val(edgeColor);
          $('.builder__preview-top-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap, .builder__preview-right-wrap').css('background', edgeColor);
          $('.builder__color-picker').css('background-color', edgeColor);
        }
      }

      // If we have image
      if (image) {
        var imageProcessed = image.indexOf('/enhance/') >= 0 ? image.replace('-/preview/5000x5000/', '-/preview/') : `${image}-/preview/`;
        $('.builder__preview-main-image').attr('src',imageProcessed);
        $('.builder__preview-main-image-2').attr('src',imageProcessed);
        $('.builder__preview-main-image-3').attr('src',imageProcessed);
        $('.builder__preview-image').data('image',imageProcessed);
        $('.builder__preview-image').attr('src',imageProcessed);
        $('.builder__line-image').val(image);

        // Update mobile nav
        $('.builder__summary-change--product').removeClass('hide');
        $('.builder__summary-change--layout').removeClass('hide');
        $('.builder__summary-change--size').removeClass('hide');
        $('.builder__summary-change--edge').removeClass('hide');
        $('.builder__summary-change--upload').removeClass('hide');

        // Get image quality
        checkQuality();

        // Reset preview
        $('.builder__preview').addClass('active');
        $('.builder__upload-photo').addClass('hide');
        $('.icon-upload').addClass('hide');
      }

      // If we have orientation
      if (orientation) {
        $('.builder__preview').addClass('flipped');
        $('.builder__preview-popup').addClass('flipped');
        $('.builder__step--frame').addClass('flipped');
        $('.builder__line-orientation').val('flipped');
      }

      // If we have filter
      if (filter) {
        $('.builder__preview-filter[data-filter='+filter+']').click();
      }

      // If we have enhance
      if (enhance) {
        $('.builder__preview-enhance').click();
      }

      // If we have frame
      if (frame) {
        $('.builder__step--frame .builder__option[data-frame-handle='+frame+']').click();

        setTimeout(function() {
          $('.builder__step--frame .builder__option[data-frame-handle='+frame+']').click();
        }, 250);

        $('.builder__step--frame').removeClass('hide');
      }

      // If we have scale
      if (scale) {
        $('.builder__line-scale').val(scale);
      }

      // If we have x co-ordinate
      if (x) {
        $('.builder__line-x').val(x);
      }

      // If we have y co-ordinate
      if (y) {
        $('.builder__line-y').val(y);
      }

      // If we have id
      if (id) {
        $('.builder__line-id').val(id);
      }

      // If we have scroll position
      if (scrollPosition) {
        $('.builder__step--product').removeClass('visible active');
        $('.builder__step--layout').addClass('option-selected');
        $('.builder__step--layout').removeClass('visible active');
        $('.builder__step--size').addClass('visible active');
        $('.builder__summary-change--product').removeClass('hide');
        $('.builder__summary-change--layout').removeClass('hide');
      } else {
        $('.builder__step').removeClass('active');
        $('.builder__step--product').addClass('active');
      }

      // If we have empty state
      if (emptyState) {
        $('.builder__option').removeClass('active');
        $('.builder__collection a').removeClass('active');
        $('.builder__summary-details-product').addClass('hide');
        $('.builder__summary-change--product').addClass('hide');
        $('.builder__summary-details-layout').addClass('hide');
        $('.builder__summary-change--layout').addClass('hide');
        $('.builder__step--product').addClass('visible active');
      } else {
        if (image) {
          $('.builder__step--product').addClass('option-selected');
          $('.builder__step--layout').addClass('option-selected');
          $('.builder__step--layout').removeClass('visible');
          $('.builder__step--size').removeClass('visible');
          $('.builder__step--upload').addClass('visible active');
          $('.builder__step--upload').removeClass('hide');
        } else {
          $('.builder__step--product').addClass('option-selected');
          $('.builder__step--layout').addClass('option-selected');
          $('.builder__step--size').addClass('visible');
          $('.builder__summary').removeClass('hide');
          $('.builder__summary').addClass('active');
        }

        // Update product / layout continue button
        $('.builder__step--product .builder__step-submit').text($('.builder__step--product .builder__step-submit').data('continue-text'));
        $('.builder__step--product .builder__step-submit').removeAttr('disabled');

        $('.builder__step--layout .builder__step-submit').text($('.builder__step--layout .builder__step-submit').data('continue-text'));
        $('.builder__step--layout .builder__step-submit').removeAttr('disabled');
      }

      // If with frame
      if (withFrame) {
        $('.builder__step--frame').attr('data-frame',withFrame);
      }

      // If uploadcare handle
      if (uploadCareHandle) {
        $('.builder__line-uploadcare-handle').val(uploadCareHandle);
        $('.builder__line-uploadcare-original-image').val(`${uploadCareHandle.split('/-/')[0]}/`);
      }

      // If go to
      if (goTo) {
        if (goTo === 'edge') {
          $('.builder__step--size').addClass('hide');
          $('.builder__step--size').removeClass('visible');
          $('.builder__step--edge').addClass('visible');
          $('.builder__step--edge').removeClass('hide');
        } else if (goTo === 'upload') {
          $('.builder__step--size').addClass('hide');
          $('.builder__step--size').removeClass('visible');
          $('.builder__step--upload').addClass('visible');
          $('.builder__step--upload').removeClass('hide');
        }
      }

      // If Shopify file
      if (shopifyFile) {
        $('.builder__line-shopify-file').val(shopifyFile);
      }
    }

    // Initialize canvas + controls and add event ready class
    setTimeout(function() {
      builderCanvas();
      builderControls();
      $('.template-builder').addClass('event-ready');
    }, 500);

    // forceAttrChange if multi-panel canvas
    if ($('.builder').hasClass('builder--two-panel-canvas') || $('.builder').hasClass('builder--three-panel-canvas')) {
      setTimeout(function() {
        forceAttrChange();
      }, 1000);
    }
  });

  // =============================================
  // Builder Canvas initialization
  // =============================================
  function builderCanvas() {
    if ($('.builder').hasClass('builder--two-panel-canvas')
      || $('.builder').hasClass('builder--three-panel-canvas')) {
      var picture = $('.builder__preview-main-image');

      // Two panel canvas
      if ($('.builder').hasClass('builder--two-panel-canvas')) {
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('width') + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('height') / 2 + '00';
        } else {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('height') / 2 + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('width') + '00';
        }
      }

      // Three panel canvas
      if ($('.builder').hasClass('builder--three-panel-canvas')) {
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('width') + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('height') / 3 + '00';
        } else {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('height') / 3 + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('width') + '00';
        }
      }

      // Initialize first guillotine
      picture.guillotine({
        width: pictureWidth,
        height: pictureHeight,
        zoomStep: 0.02,
        init: { scale: 1, x: 0, y: 0 },
        maxScale: 1000,
        onChange: function(){
          updateCropData();
        }
      });
      attrChangeFirstPanel();

      // Initialize second guillotine
      var picture2 = $('.builder__preview-main-image-2');
      picture2.guillotine({
        width: pictureWidth,
        height: pictureHeight,
        zoomStep: 0.02,
        init: { scale: 1, x: 0, y: 0 },
        maxScale: 1000,
        onChange: function(){
          updateCropData();
        }
      });
      attrChangeSecondPanel();

      // Initialize third guillotine
      if ($('.builder').hasClass('builder--three-panel-canvas')) {
        var picture3 = $('.builder__preview-main-image-3');
        picture3.guillotine({
          width: pictureWidth,
          height: pictureHeight,
          zoomStep: 0.02,
          init: { scale: 1, x: 0, y: 0 },
          maxScale: 1000,
          onChange: function(){
            updateCropData();
          }
        });
        attrChangeThirdPanel();
      }

      // Add active classes
      activeClasses();

      setTimeout(function() {
        // Zoom Range
        var zoomData = $('.builder__preview-main-image').guillotine('getData');
        var minScale = zoomData.minScale * 2;
        var maxScale = zoomData.minScale * 8;
        var halfScale = maxScale / 2.75;
        var almostMax = maxScale / 1.33;

        $('.zoom-range').prop({min:minScale, max:maxScale, value:zoomData.scale}).on('input change', function(){
          if(!$('.builder__preview-quality').hasClass('unsuitable')) {
            if (zoomData.scale > almostMax) {
              $('.builder__preview-quality').removeClass('perfect');
              $('.builder__preview-quality').removeClass('good');
              $('.builder__preview-quality').addClass('fair');
            } else if (zoomData.scale < almostMax && zoomData.scale > halfScale) {
              $('.builder__preview-quality').removeClass('perfect');
              $('.builder__preview-quality').addClass('good');
              $('.builder__preview-quality').removeClass('fair');
            } else if (zoomData.scale < almostMax && zoomData.scale < halfScale) {
              $('.builder__preview-quality').addClass('perfect');
              $('.builder__preview-quality').removeClass('good');
              $('.builder__preview-quality').removeClass('fair');
            }
          }
        });
      }, 1000);

    } else {
      var picture = $('.builder__preview-main-image');

      if ($('.builder__preview').hasClass('flipped')) {
        var pictureWidth = $('.builder__step--size .builder__option.active').data('height') + '00';
        var pictureHeight = $('.builder__step--size .builder__option.active').data('width') + '00';

        if (pictureWidth == '8500' && pictureHeight == '1100') {
          var pictureWidth = '850';
          var pictureHeight = '1100';
        }

        if (pictureWidth == '192500' && pictureHeight == '27500') {
          var pictureWidth = '1925';
          var pictureHeight = '2750';
        }
      } else {
        var pictureWidth = $('.builder__step--size .builder__option.active').data('width') + '00';
        var pictureHeight = $('.builder__step--size .builder__option.active').data('height') + '00';

        if (pictureHeight == '8500' && pictureWidth == '1100') {
          var pictureWidth = '1100';
          var pictureHeight = '850';
        }

        if (pictureHeight == '192500' && pictureWidth == '27500') {
          var pictureWidth = '2750';
          var pictureHeight = '1925';
        }
      }

      // Initialize guillotine
      picture.guillotine({
        width: pictureWidth,
        height: pictureHeight,
        zoomStep: 0.02,
        init: { scale: 1, x: 0, y: 0 },
        maxScale: 1000,
        onChange: function(){
          updateCropData();
        }
      });

      // Watch attribute changes
      attrChange();

      setTimeout(function() {
        // Zoom Range
        var zoomData = $('.builder__preview-main-image').guillotine('getData');
        var minScale = zoomData.minScale;
        var maxScale = zoomData.minScale * 5;
        var halfScale = maxScale / 2.75;
        var almostMax = maxScale / 1.33;

        $('.zoom-range').prop({min:minScale, max:maxScale, value:zoomData.scale}).on("input change", function(){
          if(!$('.builder__preview-quality').hasClass('unsuitable')) {
            if (zoomData.scale > almostMax) {
              $('.builder__preview-quality').removeClass('perfect');
              $('.builder__preview-quality').removeClass('good');
              $('.builder__preview-quality').addClass('fair');
            } else if (zoomData.scale < almostMax && zoomData.scale > halfScale) {
              $('.builder__preview-quality').removeClass('perfect');
              $('.builder__preview-quality').addClass('good');
              $('.builder__preview-quality').removeClass('fair');
            } else if (zoomData.scale < almostMax && zoomData.scale < halfScale) {
              $('.builder__preview-quality').addClass('perfect');
              $('.builder__preview-quality').removeClass('good');
              $('.builder__preview-quality').removeClass('fair');
            }
          }
        });
      }, 1000);
    }

    // Fit on load
    setTimeout(function() {
      picture.guillotine('zoomIn');
      picture.guillotine('zoomOut');
    }, 500);

    // forceAttrChange if multi-panel canvas
    if ($('.builder').hasClass('builder--two-panel-canvas') || $('.builder').hasClass('builder--three-panel-canvas')) {
      forceAttrChange();
    }

    // Set height
    var builderBottomWrapHeight = $('.builder__preview-bottom-wrap:visible').height();
    var builderPreviewColumnHeight = $('.builder__preview-column').height();
    $('.builder__preview-main-section').css('height', `${builderBottomWrapHeight + builderPreviewColumnHeight}px`);

    // Set up edges
    edgeSizing();

    if ($('.builder').hasClass('builder--has-edging')) {
      checkProgressEdging();
    } else {
      checkProgress();
    }
  }

  // =============================================
  // Update Crop Data
  // =============================================
  function updateCropData() {
    // Get image width
    if ($('.builder').hasClass('builder--two-panel-canvas')) {
      if ($('.product-single__pricing-ratio-side-by-side-panels').hasClass('hide')) {
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('width') / 2 + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('height') + '00';
        } else {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('height') + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('width') / 2 + '00';
        }
      } else {
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('width') + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('height') / 2 + '00';
        } else {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('height') / 2 + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('width') + '00';
        }
      }
    } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
      if ($('.product-single__pricing-ratio-panels-in-a-row').hasClass('hide')) {
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('width') / 3 + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('height') + '00';
        } else {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('height') + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('width') / 3 + '00';
        }
      } else {
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('width') + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('height') / 3 + '00';
        } else {
          var pictureWidth = $('.builder__step--size .builder__option.active').data('height') / 3 + '00';
          var pictureHeight = $('.builder__step--size .builder__option.active').data('width') + '00';
        }
      }
    } else {
      if ($('.builder__preview').hasClass('flipped')) {
        var pictureWidth = $('.builder__step--size .builder__option.active').data('height') + '00';
        var pictureHeight = $('.builder__step--size .builder__option.active').data('width') + '00';

        if (pictureWidth == '8500' && pictureHeight == '1100') {
          var pictureWidth = '850';
          var pictureHeight = '1100';
        }

        if (pictureWidth == '192500' && pictureHeight == '27500') {
          var pictureWidth = '1925';
          var pictureHeight = '2750';
        }
      } else {
        var pictureWidth = $('.builder__step--size .builder__option.active').data('width') + '00';
        var pictureHeight = $('.builder__step--size .builder__option.active').data('height') + '00';

        if (pictureHeight == '8500' && pictureWidth == '1100') {
          var pictureWidth = '1100';
          var pictureHeight = '850';
        }

        if (pictureHeight == '192500' && pictureWidth == '27500') {
          var pictureWidth = '2750';
          var pictureHeight = '1925';
        }
      }
    }

    var screenImage = $('.builder__preview-main-image');
    var theImage = new Image();
    theImage.src = screenImage.attr("src");
    var naturalImageWidth = theImage.width;
    var naturalImageHeight = theImage.height;

    if (naturalImageWidth >= naturalImageHeight) {
      var increaseValue = naturalImageHeight / pictureHeight;
    } else {
      var increaseValue = naturalImageWidth / pictureWidth;
    }

    // Update image width line item property
    $('.builder__line-width').val(Math.round(naturalImageWidth));

    // Get image resize for logged link
    if ($('.builder').hasClass('builder--canvas-prints')) {
      if ($('.builder__preview').hasClass('flipped')) {
        if (window.outerWidth >= 1230) {
          var canvasWidth = 300;
        } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
          var canvasWidth = 280;
        } else if (window.outerWidth <= 1024) {
          var canvasWidth = 240;
        }
      } else {
        if (window.outerWidth >= 1230) {
          var canvasWidth = 450;
        } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
          var canvasWidth = 360;
        } else if (window.outerWidth <= 1024) {
          var canvasWidth = 240;
        }
      }
    } else if ($('.builder').hasClass('builder--canvas-minis')) {
      if (window.outerWidth >= 1230) {
        var newWidthRatio = pictureWidth / 300;
      } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
        var newWidthRatio = pictureWidth / 250;
      } else if (window.outerWidth <= 1024) {
        var newWidthRatio = pictureWidth / 200;
      }
    } else if ($('.builder').hasClass('builder--two-panel-canvas')) {
      var newWidthRatio = pictureWidth / 200;
    } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
      var newWidthRatio = pictureWidth / 110;
    } else {
      if (window.outerWidth >= 1025) {
        var newWidthRatio = pictureWidth / 500;
      } else if (window.outerWidth <= 1024 && window.outerWidth >= 750) {
        var newWidthRatio = pictureWidth / 380;
      } else {
        var newWidthRatio = pictureWidth / 280;
      }
    }

    // Get image width
    var imageWidth = Math.round($('.builder__preview-main-image').width() * newWidthRatio) * increaseValue;

    // Get image src for logged link
    var imageSrc = $('.builder__preview-main-image').attr('src').split('40/')[1];

    edgeSizing();
  }

  // =============================================
  // Builder control functions
  // =============================================
  function builderControls() {
    // Zoom in button
    $('.zoom-in-button').click(function() {
      data = $('.builder__preview-main-image').guillotine('getData');

      $('.builder__preview-main-image').guillotine('zoomIn');

      var newInlineStyle = $('.builder__preview-main-image').attr('style');
      $('.builder__preview-top-wrap img, .builder__preview-right-wrap img, .builder__preview-bottom-wrap img, .builder__preview-left-wrap img, .builder__preview-image').attr('style', newInlineStyle);

      // If two panel canvas
      if ($('.builder').hasClass('builder--two-panel-canvas')) {
        $('.builder__preview-main-image-2').guillotine('zoomIn');

        // Switch panel method depending on which preview section a user was focusing on
        if ($('.builder__preview-section-1').hasClass('focus')) {
          forceAttrChange();
        } else if ($('.builder__preview-section-2').hasClass('focus')) {
          secondPanelUpdate();
          twoPanelSplit();
        }
      }

      // If three panel canvas
      if ($('.builder').hasClass('builder--three-panel-canvas')) {
        $('.builder__preview-main-image-2').guillotine('zoomIn');
        $('.builder__preview-main-image-3').guillotine('zoomIn');

        // Switch panel method depending on which preview section a user was focusing on
        if ($('.builder__preview-section-1').hasClass('focus')) {
          forceAttrChange();
        } else if ($('.builder__preview-section-2').hasClass('focus')) {
          secondPanelUpdate();
          threePanelSplit();
        } else if ($('.builder__preview-section-3').hasClass('focus')) {
          thirdPanelUpdate();
          threePanelSplit();
        }
      }

      $('.zoom-range')[0].value -= -data.zoomStep;

      // Update zoom range
      var zoomRangeValue = parseFloat($('.zoom-range').val());
      var newZoomRangeValue = zoomRangeValue + 0.1;
      $('.zoom-range').val(newZoomRangeValue).trigger('change');
    });

    // Zoom out button
    $('.zoom-out-button').click(function() {
      data = $('.builder__preview-main-image').guillotine('getData');

      if (data.scale >= 0.8) {
        $('.builder__preview-main-image').guillotine('zoomOut');

        var newInlineStyle = $('.builder__preview-main-image').attr('style');
        $('.builder__preview-top-wrap img, .builder__preview-right-wrap img, .builder__preview-bottom-wrap img, .builder__preview-left-wrap img, .builder__preview-image').attr('style', newInlineStyle);
      }

      // If two panel canvas
      if ($('.builder').hasClass('builder--two-panel-canvas')) {
        $('.builder__preview-main-image-2').guillotine('zoomOut');

        // Switch panel method depending on which preview section a user was focusing on
        if ($('.builder__preview-section-1').hasClass('focus')) {
          forceAttrChange();
        } else if ($('.builder__preview-section-2').hasClass('focus')) {
          secondPanelUpdate();
          twoPanelSplit();
        }
      }

      // If three panel canvas
      if ($('.builder').hasClass('builder--three-panel-canvas')) {
        $('.builder__preview-main-image-2').guillotine('zoomOut');
        $('.builder__preview-main-image-3').guillotine('zoomOut');

        // Switch panel method depending on which preview section a user was focusing on
        if ($('.builder__preview-section-1').hasClass('focus')) {
          forceAttrChange();
        } else if ($('.builder__preview-section-2').hasClass('focus')) {
          secondPanelUpdate();
          threePanelSplit();
        } else if ($('.builder__preview-section-3').hasClass('focus')) {
          thirdPanelUpdate();
          threePanelSplit();
        }
      }

      $('.zoom-range')[0].value -= +data.zoomStep;

      // Update zoom range
      var zoomRangeValue = parseFloat($('.zoom-range').val());
      var newZoomRangeValue = zoomRangeValue - 0.1;
      $('.zoom-range').val(newZoomRangeValue).trigger('change');
    });

    // Zoom Range
    var zoomData = $('.builder__preview-main-image').guillotine('getData');
    $('.zoom-range').prop({min:zoomData.minScale, max:zoomData.maxScale, value:zoomData.scale}).on('input change', function(){
      $('.builder__preview-main-image').guillotine('zoomCustom', $(this).val());
      $('.builder__preview-main-image-2').guillotine('zoomCustom', $(this).val());
      $('.builder__preview-main-image-3').guillotine('zoomCustom', $(this).val());
    });

    // Zoom range update panels on change
    $('.zoom-range').on('input change', function() {
      // Switch panel method depending on which preview section a user was focusing on
      if ($('.builder__preview-section-1').hasClass('focus')) {
        forceAttrChange();

      } else if ($('.builder__preview-section-2').hasClass('focus')) {
        secondPanelUpdate();

        if ($('.builder').hasClass('builder--two-panel-canvas')) {
          twoPanelSplit();
        } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
          threePanelSplit();
        }

      } else if ($('.builder__preview-section-3').hasClass('focus')) {
        thirdPanelUpdate();

        if ($('.builder').hasClass('builder--three-panel-canvas')) {
          threePanelSplit();
        }

      } else {
        forceAttrChange();
      }
    });

    // Zoom range update panels on change
    $('.zoom-range').on('change', function() {
      data = $('.builder__preview-main-image').guillotine('getData');
      $('.builder__line-scale').val(data.scale);
      $('.builder__line-x').val(data.x);
      $('.builder__line-y').val(data.y);
    });

    // Rotate right button
    $('.rotate-right-button, .rotate-left-button').click(function() {
      $('.builder__preview').toggleClass('flipped');
      $('.builder__preview-popup').toggleClass('flipped');
      $('.builder__step--frame').toggleClass('flipped');

      if ($('.builder__preview').hasClass('flipped')) {
        $('.builder__line-orientation').val('flipped');
      } else {
        $('.builder__line-orientation').val('');
      }

      $('.builder__preview-column').css('opacity','0');
      $('.builder__preview-main-image').guillotine('remove');

      // If two panel canvas
      if ($('.builder').hasClass('builder--two-panel-canvas')) {
        $('.builder__preview-main-image-2').guillotine('remove');
      }

      // If three panel canvas
      if ($('.builder').hasClass('builder--three-panel-canvas')) {
        $('.builder__preview-main-image-2').guillotine('remove');
        $('.builder__preview-main-image-3').guillotine('remove');
      }

      setTimeout(function() {
        builderCanvas();
      }, 250);

      setTimeout(function() {
        $('.builder__preview-main-image').guillotine('center');
        $('.builder__preview-main-image').guillotine('fit');

        // If two panel canvas
        if ($('.builder').hasClass('builder--two-panel-canvas')) {
          $('.builder__preview-main-image-2').guillotine('center');
          $('.builder__preview-main-image-2').guillotine('fit');
        }

        // If three panel canvas
        if ($('.builder').hasClass('builder--three-panel-canvas')) {
          $('.builder__preview-main-image-2').guillotine('center');
          $('.builder__preview-main-image-2').guillotine('fit');
          $('.builder__preview-main-image-3').guillotine('center');
          $('.builder__preview-main-image-3').guillotine('fit');
        }

        // forceAttrChange
        forceAttrChange();

        // Fade in
        $('.builder__preview-column').fadeTo('fast', 1);

        // Check quality
        checkQuality();
      }, 400);

      // Hide warning while section reloads
      $('.builder__preview-warning').addClass('hide');

      setTimeout(function() {
        $('.builder__preview-warning').removeClass('hide');
      }, 1500);
    });
  }

  // =============================================
  // Watch for user dragging and update values
  // =============================================
  function attrChange() {
    $('.builder__preview-section-1 .builder__preview-wrap .guillotine-canvas').attrchange({
      trackValues: true,
      callback: function() {
        firstPanelUpdate();
      }
    });
  }

  // =============================================
  // Force an attribute change
  // =============================================
  function forceAttrChange() {
    firstPanelUpdate();
    if ($('.builder').hasClass('builder--two-panel-canvas')) {
      twoPanelSplit();
    } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
      threePanelSplit();
    }
  }

  // =============================================
  // Watch for user dragging on first panel and update values
  // =============================================
  function attrChangeFirstPanel() {
    $('.builder__preview-section-1 .builder__preview-wrap .guillotine-canvas').attrchange({
      trackValues: true,
      callback: function() {
        if ($('.builder__preview-section-1').hasClass('active')) {
          firstPanelUpdate();

          if ($('.builder').hasClass('builder--two-panel-canvas')) {
            twoPanelSplit();
          } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
            threePanelSplit();
          }
        }
      }
    });
  }

  // =============================================
  // Watch for user dragging on second panel and update values
  // =============================================
  function attrChangeSecondPanel() {
    $('.builder__preview-section-2 .builder__preview-wrap .guillotine-canvas').attrchange({
      trackValues: true,
      callback: function() {
        if ($('.builder__preview-section-2').hasClass('active')) {
          secondPanelUpdate();

          if ($('.builder').hasClass('builder--two-panel-canvas')) {
            twoPanelSplit();
          } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
            threePanelSplit();
          }
        }
      }
    });
  }

  // =============================================
  // Watch for user dragging on third panel and update values
  // =============================================
  function attrChangeThirdPanel() {
    // Watch for user dragging and update values
    $('.builder__preview-section-3 .builder__preview-wrap .guillotine-canvas').attrchange({
      trackValues: true,
      callback: function() {
        if ($('.builder__preview-section-3').hasClass('active')) {
          thirdPanelUpdate();
          threePanelSplit();
        }
      }
    });
  }

  // =============================================
  // First panel update
  // =============================================
  function firstPanelUpdate() {
    var guillotineWindowStyle = $('.builder__preview-section-1 .builder__preview-wrap .guillotine-window').attr('style');
    var guillotineCanvasStyle = $('.builder__preview-section-1 .builder__preview-wrap .guillotine-canvas').attr('style');
    var guillotineCanvasLeft = $('.builder__preview-section-1 .builder__preview-wrap .guillotine-canvas').css('left');

    // Apply style to secondary preview section
    $('.builder__preview-section-2 .builder__preview-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-section-2 .builder__preview-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    $('.builder__preview-section-3 .builder__preview-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-section-3 .builder__preview-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);

    panelPositioning(guillotineWindowStyle,guillotineCanvasStyle,guillotineCanvasLeft);
    singleCanvasPositionCheck();
    multiPanelPositionCheck();
  }

  // =============================================
  // Single canvas position check
  // =============================================
  function singleCanvasPositionCheck() {
    if ($('.builder').hasClass('builder--canvas-prints') || $('.builder').hasClass('builder--canvas-minis')) {
      if ($('.builder__preview').hasClass('wrapped')) {
        if ($('.builder__preview').hasClass('flipped') && $('.builder__preview').hasClass('panorama-print')) {
          var canvasWidth = 120;
        } else if ($('.builder__preview').hasClass('flipped') && $('.builder__preview').hasClass('double-width-print')) {
          var canvasWidth = 160;
        } else {

          if ($('.builder').hasClass('builder--canvas-minis')) {
            if (window.outerWidth >= 1230) {
              var canvasWidth = 300;
            } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
              var canvasWidth = 250;
            } else if (window.outerWidth <= 1024) {
              var canvasWidth = 200;
            }
          } else {
            if ($('.builder__preview').hasClass('flipped')) {
              if (window.outerWidth >= 1230) {
                var canvasWidth = 300;
              } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
                var canvasWidth = 280;
              } else if (window.outerWidth <= 1024) {
                var canvasWidth = 240;
              }
            } else {
              if (window.outerWidth >= 1230) {
                var canvasWidth = 450;
              } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
                var canvasWidth = 360;
              } else if (window.outerWidth <= 1024) {
                var canvasWidth = 240;
              }
            }
          }
        }

        // Set up edge size
        if ($('.builder__preview').hasClass('flipped')) {
          var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('height');
        } else {
          var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('width');
        }

        var edgePercentage = 1.77165 / pictureWidthOriginal;
        var edgeWidth = canvasWidth * edgePercentage;
        var sideWidth = edgeWidth;

        // Right position
        var rightImageWrapPosition = ($(window).width() - ($('.builder__preview-wrap').offset().left + $('.builder__preview-wrap').outerWidth()) - sideWidth);
        var rightImagePosition = ($(window).width() - ($('.builder__preview-main-image').offset().left + $('.builder__preview-main-image').outerWidth()));

        // Bottom position
        var bottomImageWrapPosition = ($(window).height() - ($('.builder__preview-wrap').offset().top + $('.builder__preview-wrap').outerHeight()) - sideWidth);
        var bottomImagePosition = ($(window).height() - ($('.builder__preview-main-image').offset().top + $('.builder__preview-main-image').outerHeight()));

        // Left position
        var leftImageWrapPosition = $('.builder__preview-wrap').offset().left - sideWidth;
        var leftImagePosition = $('.builder__preview-main-image').offset().left;

        // Top position
        var topImageWrapPosition = $('.builder__preview-wrap').offset().top - sideWidth;
        var topImagePosition = $('.builder__preview-main-image').offset().top;

        if (rightImagePosition < rightImageWrapPosition && leftImagePosition < leftImageWrapPosition && topImagePosition < topImageWrapPosition && bottomImagePosition < bottomImageWrapPosition) {
          $('.builder__preview-warning').html('');
        } else {
          //$('.builder__preview-warning').html(`<div class="builder__preview-error">${window.theme.builder.canvasPositionError}</div>`);
        }

        checkProgress();
      }
    }
  }

  // =============================================
  // Multi Panel position check
  // =============================================
  function multiPanelPositionCheck() {
    if ($('.builder__preview').hasClass('wrapped')) {
      if ($('.builder').hasClass('builder--two-panel-canvas')) {
        var canvasWidth = 200
      } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
        var canvasWidth = 110;
      }

      // Set up edge size
      var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('width');

      var edgePercentage = 1.77165 / pictureWidthOriginal;
      var edgeWidth = canvasWidth * edgePercentage;
      var sideWidth = edgeWidth;
    } else {
      var sideWidth = 0;
    }

    // Image 1
    // Right position
    var rightImageWrapPosition = ($(window).width() - ($('.builder__preview-section-1 .builder__preview-wrap').offset().left + $('.builder__preview-section-1 .builder__preview-wrap').outerWidth()) - sideWidth);
    var rightImagePosition = ($(window).width() - ($('.builder__preview-section-1 .builder__preview-main-image').offset().left + $('.builder__preview-section-1 .builder__preview-main-image').outerWidth()));

    // Bottom position
    var bottomImageWrapPosition = ($(window).height() - ($('.builder__preview-section-1 .builder__preview-wrap').offset().top + $('.builder__preview-section-1 .builder__preview-wrap').outerHeight()) - sideWidth);
    var bottomImagePosition = ($(window).height() - ($('.builder__preview-section-1 .builder__preview-main-image').offset().top + $('.builder__preview-section-1 .builder__preview-main-image').outerHeight()));

    // Left position
    var leftImageWrapPosition = $('.builder__preview-section-1 .builder__preview-wrap').offset().left - sideWidth;
    var leftImagePosition = $('.builder__preview-section-1 .builder__preview-main-image').offset().left;

    // Top position
    var topImageWrapPosition = $('.builder__preview-section-1 .builder__preview-wrap').offset().top - sideWidth;
    var topImagePosition = $('.builder__preview-section-1 .builder__preview-main-image').offset().top;

    // Image 2
    if ($('.builder').hasClass('builder--two-panel-canvas') || $('.builder').hasClass('builder--three-panel-canvas')) {
      // Right position
      var image2RightImageWrapPosition = ($(window).width() - ($('.builder__preview-section-2 .builder__preview-wrap').offset().left + $('.builder__preview-section-2 .builder__preview-wrap').outerWidth()) - sideWidth);
      var image2RightImagePosition = ($(window).width() - ($('.builder__preview-section-2 .builder__preview-main-image-2').offset().left + $('.builder__preview-section-2 .builder__preview-main-image-2').outerWidth()));

      // Bottom position
      var image2BottomImageWrapPosition = ($(window).height() - ($('.builder__preview-section-2 .builder__preview-wrap').offset().top + $('.builder__preview-section-2 .builder__preview-wrap').outerHeight()) - sideWidth);
      var image2BottomImagePosition = ($(window).height() - ($('.builder__preview-section-2 .builder__preview-main-image-2').offset().top + $('.builder__preview-section-2 .builder__preview-main-image-2').outerHeight()));

      // Left position
      var image2LeftImageWrapPosition = $('.builder__preview-section-2 .builder__preview-wrap').offset().left - sideWidth;
      var image2LeftImagePosition = $('.builder__preview-section-2 .builder__preview-main-image-2').offset().left;

      // Top position
      var image2TopImageWrapPosition = $('.builder__preview-section-2 .builder__preview-wrap').offset().top - sideWidth;
      var image2TopImagePosition = $('.builder__preview-section-2 .builder__preview-main-image-2').offset().top;
    }

    // Image 3
    if ($('.builder').hasClass('builder--three-panel-canvas')) {
      // Right position
      var image3RightImageWrapPosition = ($(window).width() - ($('.builder__preview-section-3 .builder__preview-wrap').offset().left + $('.builder__preview-section-3 .builder__preview-wrap').outerWidth()) - sideWidth);
      var image3RightImagePosition = ($(window).width() - ($('.builder__preview-section-3 .builder__preview-main-image-3').offset().left + $('.builder__preview-section-3 .builder__preview-main-image-3').outerWidth()));

      // Bottom position
      var image3BottomImageWrapPosition = ($(window).height() - ($('.builder__preview-section-3 .builder__preview-wrap').offset().top + $('.builder__preview-section-3 .builder__preview-wrap').outerHeight()) - sideWidth);
      var image3BottomImagePosition = ($(window).height() - ($('.builder__preview-section-3 .builder__preview-main-image-3').offset().top + $('.builder__preview-section-3 .builder__preview-main-image-3').outerHeight()));

      // Left position
      var image3LeftImageWrapPosition = $('.builder__preview-section-3 .builder__preview-wrap').offset().left - sideWidth;
      var image3LeftImagePosition = $('.builder__preview-section-3 .builder__preview-main-image-3').offset().left;

      // Top position
      var image3TopImageWrapPosition = $('.builder__preview-section-3 .builder__preview-wrap').offset().top - sideWidth;
      var image3TopImagePosition = $('.builder__preview-section-3 .builder__preview-main-image-3').offset().top;
    }

    if ($('.builder').hasClass('builder--two-panel-canvas')) {
      if (rightImagePosition < rightImageWrapPosition && leftImagePosition < leftImageWrapPosition && topImagePosition < topImageWrapPosition && bottomImagePosition < bottomImageWrapPosition && image2RightImagePosition < image2RightImageWrapPosition && image2LeftImagePosition < image2LeftImageWrapPosition && image2TopImagePosition < image2TopImageWrapPosition && image2BottomImagePosition < image2BottomImageWrapPosition) {
        $('.builder__preview-warning').html('');
      } else {
        //$('.builder__preview-warning').html(`<div class="builder__preview-error">${window.theme.builder.canvasPositionError}</div>`);
      }
    } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
      if (rightImagePosition < rightImageWrapPosition && leftImagePosition < leftImageWrapPosition && topImagePosition < topImageWrapPosition && bottomImagePosition < bottomImageWrapPosition && image2RightImagePosition < image2RightImageWrapPosition && image2LeftImagePosition < image2LeftImageWrapPosition && image2TopImagePosition < image2TopImageWrapPosition && image2BottomImagePosition < image2BottomImageWrapPosition && image3RightImagePosition < image3RightImageWrapPosition && image3LeftImagePosition < image3LeftImageWrapPosition && image3TopImagePosition < image3TopImageWrapPosition && image3BottomImagePosition < image3BottomImageWrapPosition) {
        $('.builder__preview-warning').html('');
      } else {
        //$('.builder__preview-warning').html(`<div class="builder__preview-error">${window.theme.builder.canvasPositionError}</div>`);
      }
    }

    checkProgress();
  }

  // =============================================
  // Second panel update
  // =============================================
  function secondPanelUpdate() {
    var guillotineWindowStyle = $('.builder__preview-section-2 .builder__preview-wrap .guillotine-window').attr('style');
    var guillotineCanvasStyle = $('.builder__preview-section-2 .builder__preview-wrap .guillotine-canvas').attr('style');
    var guillotineCanvasLeft = $('.builder__preview-section-2 .builder__preview-wrap .guillotine-canvas').css('left');

    // Apply style to secondary preview section
    $('.builder__preview-section-1 .builder__preview-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-section-1 .builder__preview-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    $('.builder__preview-section-3 .builder__preview-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-section-3 .builder__preview-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);

    panelPositioning(guillotineWindowStyle,guillotineCanvasStyle,guillotineCanvasLeft);
    multiPanelPositionCheck();
  }

  // =============================================
  // Third panel update
  // =============================================
  function thirdPanelUpdate() {
    var guillotineWindowStyle = $('.builder__preview-section-3 .builder__preview-wrap .guillotine-window').attr('style');
    var guillotineCanvasStyle = $('.builder__preview-section-3 .builder__preview-wrap .guillotine-canvas').attr('style');
    var guillotineCanvasLeft = $('.builder__preview-section-3 .builder__preview-wrap .guillotine-canvas').css('left');

    // Apply style to secondary preview section
    $('.builder__preview-section-1 .builder__preview-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-section-1 .builder__preview-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    $('.builder__preview-section-2 .builder__preview-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-section-2 .builder__preview-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);

    panelPositioning(guillotineWindowStyle,guillotineCanvasStyle,guillotineCanvasLeft);
    multiPanelPositionCheck();
  }

  // =============================================
  // Panel positioning, when user drags a panel, make sure we update the others
  // =============================================
  function panelPositioning(guillotineWindowStyle,guillotineCanvasStyle,guillotineCanvasLeft,canvasHeight,canvasWidth) {
    var canvasHeight = $('.builder__preview-wrap').height() + 4 + 'px';
    var canvasWidth = $('.builder__preview-wrap').width() + 'px';

    // Set up top
    $('.builder__preview-top-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-top-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    $('.builder__preview-top-wrap').css('width',canvasWidth);

    // Set up right
    if ($('.builder__preview').hasClass('wrapped')) {
      $('.builder__preview-right-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
      $('.builder__preview-right-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    } else {
      $('.builder__preview-right-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
      $('.builder__preview-right-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle).css('right',guillotineCanvasLeft).css('left','auto');
    }

    $('.builder__preview-right-wrap').css('height',canvasHeight);
    $('.builder__preview-right-wrap .guillotine-window').css('height',canvasHeight).css('width',canvasWidth);

    if ($('.builder__preview').hasClass('wrapped')) {
      $('.builder__preview-right-wrap img').css('margin-left', '-' + canvasWidth);
    } else {
      $('.builder__preview-right-wrap img').css('margin-left', '0px');
    }

    // Set up bottom
    $('.builder__preview-bottom-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-bottom-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    $('.builder__preview-bottom-wrap').css('width',canvasWidth);

    // If two panel
    if ($('.builder').hasClass('builder--two-panel-canvas')) {
      if ($('.builder__preview').hasClass('wrapped')) {
        $('.builder__preview-bottom-wrap img').css('margin-top', '-' + canvasHeight);
      } else {
        var canvasHeightValMirror = $('.builder__preview-wrap').height() - 34 + 'px';
        $('.builder__preview-bottom-wrap img').css('margin-top', '-' + canvasHeightValMirror);
      }

    // If three panel
    } else if ($('.builder').hasClass('builder--three-panel-canvas')) {
      if ($('.builder__preview').hasClass('wrapped')) {
        var newCanvasHeight = $('.builder__preview-wrap').height() - 5 + 'px';
        $('.builder__preview-bottom-wrap img').css('margin-top', '-' + newCanvasHeight);
      } else {
        var canvasHeightValMirror = $('.builder__preview-wrap').height() - 34 + 'px';
        $('.builder__preview-bottom-wrap img').css('margin-top', '-' + canvasHeightValMirror);
      }

    // If one panel
    } else {
      if ($('.builder__preview').hasClass('wrapped')) {
        $('.builder__preview-bottom-wrap img').css('margin-top', '-' + canvasHeight);
      } else {
        $('.builder__preview-bottom-wrap img').css('margin-top', '0');
      }
    }

    // Set up left
    $('.builder__preview-left-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-left-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
    $('.builder__preview-left-wrap').css('height',canvasHeight);
    $('.builder__preview-left-wrap .guillotine-window').css('height',canvasHeight).css('width',canvasWidth);

    // Set up popup
    $('.builder__preview-popup-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__preview-popup-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);

    // Set up frame preview
    $('.builder__frame-image-wrap .guillotine-window').removeAttr('style').attr('style',guillotineWindowStyle);
    $('.builder__frame-image-wrap .guillotine-canvas').removeAttr('style').attr('style',guillotineCanvasStyle);
  }

  // =============================================
  // Edge sizing
  // =============================================
  function edgeSizing() {
    // Single canvas
    if ($('.builder').hasClass('builder--canvas-prints') || $('.builder').hasClass('builder--canvas-minis')) {
      if ($('.builder__preview').hasClass('flipped') && $('.builder__preview').hasClass('panorama-print')) {
        var canvasWidth = 120;
      } else if ($('.builder__preview').hasClass('flipped') && $('.builder__preview').hasClass('double-width-print')) {
        var canvasWidth = 160;
      } else {

        if ($('.builder').hasClass('builder--canvas-minis')) {
          if (window.outerWidth >= 1230) {
            var canvasWidth = 300;
          } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
            var canvasWidth = 250;
          } else if (window.outerWidth <= 1024) {
            var canvasWidth = 200;
          }
        } else {
          if ($('.builder__preview').hasClass('flipped')) {
            if (window.outerWidth >= 1230) {
              var canvasWidth = 300;
            } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
              var canvasWidth = 280;
            } else if (window.outerWidth <= 1024) {
              var canvasWidth = 240;
            }
          } else {
            if (window.outerWidth >= 1230) {
              var canvasWidth = 450;
            } else if (window.outerWidth < 1230 && window.outerWidth >= 1025) {
              var canvasWidth = 360;
            } else if (window.outerWidth <= 1024) {
              var canvasWidth = 240;
            }
          }
        }
      }

      // Set up edge size
      if ($('.builder__preview').hasClass('flipped')) {
        var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('height');
      } else {
        var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('width');
      }

      var edgePercentage = 1.77165 / pictureWidthOriginal;
      var edgeWidth = canvasWidth * edgePercentage + 'px';

      $('.builder__preview-top-wrap, .builder__preview-bottom-wrap').css('height',edgeWidth);
      $('.builder__preview-top-wrap, .builder__preview-bottom-wrap').css('background-size',`100% ${edgeWidth}`);
      $('.builder__preview-left-wrap, .builder__preview-right-wrap').css('width',edgeWidth);
      $('.builder__preview-left-wrap, .builder__preview-right-wrap').css('background-size',`${edgeWidth} 100%`);
      $('.builder__preview-left-wrap').css('top',edgeWidth);
      $('.builder__preview-section').css('padding-left',edgeWidth);

      // Position edge images
      $('.builder__preview.wrapped .builder__preview-top-wrap img').css('margin-top',edgeWidth);
      $('.builder__preview.wrapped .builder__preview-left-wrap img').css('margin-left',edgeWidth);

      // Set up container width
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // If firefox add an extra pixel for padding issues
      if (isFirefox == true) {
        var edgeWidthInteger = canvasWidth * edgePercentage;
        var sectionWidth = canvasWidth + (edgeWidthInteger * 2) + 1 + 'px';
      } else {
        var edgeWidthInteger = canvasWidth * edgePercentage;
        var sectionWidth = canvasWidth + (edgeWidthInteger * 2) + 'px';
      }

      $('.builder__preview-column, .builder__preview-section').css('width',sectionWidth);
    }

    // Two panel canvas
    if ($('.builder').hasClass('builder--two-panel-canvas')) {
      var canvasWidth = 200;

      // Set up edge size
      var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('width');

      var edgePercentage = 1.77165 / pictureWidthOriginal;
      var edgeWidth = (canvasWidth * edgePercentage) + 'px';
      var edgeWidthVal = (canvasWidth * edgePercentage);
      var edgeWidthDouble = (edgeWidthVal * 2) + 'px';
      var edgeWidthTriple = (edgeWidthVal * 3) + 'px';

      $('.builder__preview-top-wrap, .builder__preview-bottom-wrap').css('height',edgeWidth);
      $('.builder__preview-left-wrap, .builder__preview-right-wrap').css('width',edgeWidth).css('margin-top','0');
      $('.builder__preview-left-wrap').css('top',edgeWidth);
      $('.builder__preview-section').css('padding-left',edgeWidth);

      // Position edge images
      $('.builder__preview.wrapped .builder__preview-section-1 .builder__preview-top-wrap img').css('margin-top',edgeWidth);
      $('.builder__preview.wrapped .builder__preview-section-1 .builder__preview-left-wrap img').css('margin-left',edgeWidth);

      // Position second panel
      $('.builder__preview-section-2 .builder__preview-left-wrap img').css('left','0');
      $('.builder__preview-section-2 .builder__preview-main-image-2').css('left','0');
      $('.builder__preview-section-2 .builder__preview-top-wrap img').css('left','0').css('margin-top',edgeWidth);
      $('.builder__preview-section-2 .builder__preview-right-wrap img').css('left','0');
      $('.builder__preview-section-2 .builder__preview-bottom-wrap img').css('left','0').css('top',edgeWidth);
      $('.builder__preview-section-2 .builder__preview-main-image-2').css('left','0');

      // Set up container width
      var edgeWidthInteger = canvasWidth * edgePercentage;
      var sectionWidth = canvasWidth + (edgeWidthInteger * 2) + 'px';
      var columnWidth = (canvasWidth * 2) + (edgeWidthInteger * 2) + 45 + 'px';
      $('.builder__preview-section').css('width',sectionWidth);
      $('.builder__preview-column').css('width',columnWidth);
    }

    // Three panel canvas
    if ($('.builder').hasClass('builder--three-panel-canvas')) {
      var canvasWidth = 110;

      // Set up edge size
      var pictureWidthOriginal = $('.builder__step--size .builder__option.active').data('width');

      var edgePercentage = 1.77165 / pictureWidthOriginal;
      var edgeWidth = (canvasWidth * edgePercentage) + 'px';
      var edgeWidthVal = (canvasWidth * edgePercentage);
      var edgeWidthDouble = (edgeWidthVal * 2) + 'px';
      var edgeWidthTriple = (edgeWidthVal * 3) + 'px';
      var edgeWidthQuad = (edgeWidthVal * 4) + 'px';
      var edgeWidthFifth = (edgeWidthVal * 5) + 'px';

      $('.builder__preview-top-wrap, .builder__preview-bottom-wrap').css('height',edgeWidth);
      $('.builder__preview-left-wrap, .builder__preview-right-wrap').css('width',edgeWidth).css('margin-top','0');
      $('.builder__preview-left-wrap').css('top',edgeWidth);
      $('.builder__preview-section').css('padding-left',edgeWidth);

      // Position edge images
      $('.builder__preview.wrapped .builder__preview-section-1 .builder__preview-top-wrap img').css('margin-top',edgeWidth);
      $('.builder__preview.wrapped .builder__preview-section-1 .builder__preview-left-wrap img').css('margin-left',edgeWidth);

      // Position second and third panels
      $('.builder__preview.wrapped .builder__preview-section-2 .builder__preview-left-wrap img').css('left','0');
      $('.builder__preview.wrapped .builder__preview-section-2 .builder__preview-main-image-2').css('left','0');
      $('.builder__preview.wrapped .builder__preview-section-2 .builder__preview-top-wrap img').css('left','0').css('margin-top',edgeWidth);
      $('.builder__preview.wrapped .builder__preview-section-2 .builder__preview-right-wrap img').css('left','0');
      $('.builder__preview.wrapped .builder__preview-section-2 .builder__preview-bottom-wrap img').css('left','0').css('top',edgeWidth);

      $('.builder__preview.wrapped .builder__preview-section-3 .builder__preview-left-wrap img').css('left','0');
      $('.builder__preview.wrapped .builder__preview-section-3 .builder__preview-main-image-3').css('left','0');
      $('.builder__preview.wrapped .builder__preview-section-3 .builder__preview-top-wrap img').css('left','0').css('margin-top',edgeWidth);
      $('.builder__preview.wrapped .builder__preview-section-3 .builder__preview-right-wrap img').css('left','0');
      $('.builder__preview.wrapped .builder__preview-section-3 .builder__preview-bottom-wrap img').css('left','0').css('top',edgeWidth);

      // Set up container width
      var edgeWidthInteger = canvasWidth * edgePercentage;
      var sectionWidth = canvasWidth + (edgeWidthInteger * 2) + 'px';
      var columnWidth = (canvasWidth * 3) + (edgeWidthInteger * 2) + 50 + 'px';
      $('.builder__preview-section').css('width',sectionWidth);
      $('.builder__preview-column').css('width',columnWidth);
    }

    // Set up edge images
    if ($('.builder__preview').hasClass('wrapped')) {
      var mainImageSrc = $('.builder__preview-main-image').attr('src');
      var mainImageBaseUrl = mainImageSrc.split('-/')[0];
      var mainImageDimensions = mainImageSrc.split('/crop/')[1]?.split('/')[0];
      var mainImageWidth = parseInt(mainImageDimensions?.split('x')[0]);
      var mainImageHeight = parseInt(mainImageDimensions?.split('x')[1]);
      var mainImageCropPosition = mainImageSrc.split('/crop/')[1]?.split('/')[1].split('/')[0];
      var mainImageCropX = parseInt(mainImageCropPosition?.split(',')[0]);
      var mainImageCropY = parseInt(mainImageCropPosition?.split(',')[1]);
      var mainImageRotation = mainImageSrc.indexOf('/rotate/') >= 0 ? `-/rotate/${mainImageSrc.split('/rotate/')[1]}` : null;

      // Vertical Crop Ratio
      if (mainImageHeight > mainImageWidth) {
        if ($('.builder__preview').hasClass('flipped')) {
          if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
          } else if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
          } else {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
          }
        } else {
          if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
          } else if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
          } else {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
          }
        }
      // Horizontal Crop Ratio
      } else {
        if ($('.builder__preview').hasClass('flipped')) {
          if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
          } else {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
          }
        } else {
          if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
          } else {
            $('.builder__preview-top-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY - 120}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-right-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX + mainImageWidth},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-bottom-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/${mainImageWidth}x120/${mainImageCropX},${mainImageCropY + mainImageHeight}/` : ''}-/preview/${mainImageRotation}')`);
            $('.builder__preview-left-wrap').css('background-image', `url('${mainImageBaseUrl}${mainImageCropPosition ? `-/crop/120x${mainImageHeight}/${mainImageCropX - 120},${mainImageCropY}/` : ''}-/preview/${mainImageRotation}')`);
          }
        }
      }

      if (!mainImageCropPosition) {
        $('.builder__preview-top-wrap, .builder__preview-right-wrap, .builder__preview-bottom-wrap, .builder__preview-left-wrap').css('background-image', '');
      }

      validateEdges();
    }
  }

  function validateEdges() {
    var mainImageSrc = $('.builder__preview-main-image').attr('src');
    var mainImageDimensions = mainImageSrc.split('/crop/')[1]?.split('/')[0];
    var mainImageWidth = parseInt(mainImageDimensions?.split('x')[0]);
    var mainImageHeight = parseInt(mainImageDimensions?.split('x')[1]);
    var mainImageRotation = mainImageSrc.indexOf('/rotate/') >= 0 ? `-/rotate/${mainImageSrc.split('/rotate/')[1]}` : null;

    var originalImageWidth = parseInt($('.builder__preview-main-image').attr('data-original-width'));
    var originalImageHeight = parseInt($('.builder__preview-main-image').attr('data-original-height'));
    var error = false;

    // =============================================
    // Validate top
    // =============================================
    var topImageSrc = $('.builder__preview-top-wrap').css('background-image');
    var topWrapHeight = parseInt($('.builder__preview-top-wrap').css('height').replace('px', ''));
    var topImageCropPosition = topImageSrc?.split('/crop/')[1]?.split('/')[1].split('/')[0];
    var topImageCropY = parseInt(topImageCropPosition?.split(',')[1]);
    var topImageCropX = parseInt(topImageCropPosition?.split(',')[0]);

    // Vertical crop ratio
    if (mainImageHeight > mainImageWidth) {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (topImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        } else {
          if (topImageCropY + topWrapHeight < topWrapHeight) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (topImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        } else {
          if (topImageCropX + topWrapHeight < topWrapHeight) {
            error = true;
          }
        }
      }
    // Horizontal crop ratio
    } else {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (topImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        } else {
          if (topImageCropX + topWrapHeight < topWrapHeight) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (topImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        } else {
          if (topImageCropY + topWrapHeight < topWrapHeight) {
            error = true;
          }
        }
      }
    }

    // =============================================
    // Validate right
    // =============================================
    var rightImageSrc = $('.builder__preview-right-wrap').css('background-image');
    var rightWrapWidth = parseInt($('.builder__preview-right-wrap').css('width').replace('px', ''));
    var rightImageCropPosition =  rightImageSrc?.split('/crop/')[1]?.split('/')[1].split('/')[0];
    var rightImageCropX = parseInt(rightImageCropPosition?.split(',')[0]);
    var rightImageCropY = parseInt(rightImageCropPosition?.split(',')[1]);

    // Vertical crop ratio
    if (mainImageHeight > mainImageWidth) {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (rightImageCropX + rightWrapWidth < rightWrapWidth) {
            error = true;
          }
        } else {
          if (rightImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (rightImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        } else {
          if (rightImageCropY + rightWrapWidth < rightWrapWidth) {
            error = true;
          }
        }
      }
    // Horizontal crop ratio
    } else {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (rightImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        } else {
          if (rightImageCropY + rightWrapWidth < rightWrapWidth) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (rightImageCropX + rightWrapWidth < rightWrapWidth) {
            error = true;
          }
        } else {
          if (rightImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        }
      }
    }

    // =============================================
    // Validate bottom
    // =============================================
    var bottomImageSrc = $('.builder__preview-bottom-wrap').css('background-image');
    var bottomWrapHeight = parseInt($('.builder__preview-bottom-wrap').css('height').replace('px', ''));
    var bottomImageCropPosition = bottomImageSrc?.split('/crop/')[1]?.split('/')[1].split('/')[0];
    var bottomImageCropX = parseInt(bottomImageCropPosition?.split(',')[0]);
    var bottomImageCropY = parseInt(bottomImageCropPosition?.split(',')[1]);

    // Vertical crop ratio
    if (mainImageHeight > mainImageWidth) {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (bottomImageCropY + bottomWrapHeight < bottomWrapHeight) {
            error = true;
          }
        } else {
          if (bottomImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (bottomImageCropX + bottomWrapHeight < bottomWrapHeight) {
            error = true;
          }
        } else {
          if (bottomImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        }
      }
    // Horizontal crop ratio
    } else {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (bottomImageCropX + bottomWrapHeight < bottomWrapHeight) {
            error = true;
          }
        } else {
          if (bottomImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (bottomImageCropY + bottomWrapHeight < bottomWrapHeight) {
            error = true;
          }
        } else {
          if (bottomImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        }
      }
    }

    // =============================================
    // Validate left
    // =============================================
    var leftImageSrc = $('.builder__preview-left-wrap').css('background-image');
    var leftWrapWidth = parseInt($('.builder__preview-left-wrap').css('width').replace('px', ''));
    var leftImageCropPosition =  leftImageSrc?.split('/crop/')[1]?.split('/')[1].split('/')[0];
    var leftImageCropX = parseInt(leftImageCropPosition?.split(',')[0]);
    var leftImageCropY = parseInt(leftImageCropPosition?.split(',')[1]);

    // Vertical crop ratio
    if (mainImageHeight > mainImageWidth) {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (leftImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        } else {
          if (leftImageCropX + leftWrapWidth < leftWrapWidth) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (leftImageCropY + leftWrapWidth < leftWrapWidth) {
            error = true;
          }
        } else {
          if (leftImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        }
      }
    // Horizontal crop ratio
    } else {
      if ($('.builder__preview').hasClass('flipped')) {
        if (mainImageRotation && mainImageRotation.indexOf('90') >= 0) {
          if (leftImageCropY + leftWrapWidth < leftWrapWidth) {
            error = true;
          }
        } else {
          if (leftImageCropY + 120 > originalImageHeight) {
            error = true;
          }
        }
      } else {
        if (mainImageRotation && mainImageRotation.indexOf('180') >= 0) {
          if (leftImageCropX + 120 > originalImageWidth) {
            error = true;
          }
        } else {
          if (leftImageCropX + leftWrapWidth < leftWrapWidth) {
            error = true;
          }
        }
      }
    }

    if (error) {
      $('.builder__preview-warning').removeClass('hidden');
      $('.builder__preview-warning').html(`<span class="unsuitable-quality"><svg fill=none height=48 viewBox="0 0 48 48"width=48 xmlns=http://www.w3.org/2000/svg><circle cx=24 cy=24 fill=#F06161 r=24 /><g clip-path=url(#clip0_5737_3457)><path d="M24 35C30.0751 35 35 30.0751 35 24C35 17.9249 30.0751 13 24 13C17.9249 13 13 17.9249 13 24C13 30.0751 17.9249 35 24 35Z"stroke=black stroke-linecap=square stroke-miterlimit=10 stroke-width=2 /><path d="M24 19V25"stroke=black stroke-linecap=round stroke-miterlimit=10 stroke-width=2 /><path d="M24 30C24.5523 30 25 29.5523 25 29C25 28.4477 24.5523 28 24 28C23.4477 28 23 28.4477 23 29C23 29.5523 23.4477 30 24 30Z"fill=black /></g><defs><clipPath id=clip0_5737_3457><rect fill=white height=24 transform="translate(12 12)"width=24 /></clipPath></defs></svg> ${window.theme.builder.canvasPositionError}</span>`);

      setTimeout(() => {
        $('.builder__step--upload .builder__step-submit').attr('disabled', true);
      }, 1000);
    } else {
      $('.builder__preview-warning').addClass('hidden');
      $('.builder__preview-warning').html('');

      setTimeout(() => {
        $('.builder__step--upload .builder__step-submit').removeAttr('disabled');
      }, 1000);
    }
  }

  // =============================================
  // Image positioning for two panel split
  // =============================================
  function twoPanelSplit() {
    $('.builder__preview-main-image-2').css('margin-left', '-200px');
    $('.builder__preview-section-2 .builder__preview-left-wrap img').css('margin-left', '-200px');
    $('.builder__preview-section-2 .builder__preview-bottom-wrap img').css('margin-left', '-200px');
    $('.builder__preview-section-2 .builder__preview-top-wrap img').css('margin-left', '-200px');
    $('.builder__preview-section-2 .builder__preview-right-wrap img').css('margin-left', '-200px');
  }

  // =============================================
  // Image positioning for three panel split
  // =============================================
  function threePanelSplit() {
    $('.builder__preview-main-image-2').css('margin-left', '-100px');
    $('.builder__preview-section-2 .builder__preview-left-wrap img').css('margin-left', '-100px');
    $('.builder__preview-section-2 .builder__preview-bottom-wrap img').css('margin-left', '-100px');
    $('.builder__preview-section-2 .builder__preview-top-wrap img').css('margin-left', '-100px');
    $('.builder__preview-section-2 .builder__preview-right-wrap img').css('margin-left', '-100px');

    $('.builder__preview-main-image-3').css('margin-left', '-200px');
    $('.builder__preview-section-3 .builder__preview-left-wrap img').css('margin-left', '-200px');
    $('.builder__preview-section-3 .builder__preview-bottom-wrap img').css('margin-left', '-200px');
    $('.builder__preview-section-3 .builder__preview-top-wrap img').css('margin-left', '-200px');
    $('.builder__preview-section-3 .builder__preview-right-wrap img').css('margin-left', '-200px');
  }

  // =============================================
  // Check image quality
  // =============================================
  function checkQuality() {
    $('.builder__preview-quality').removeClass('perfect good fair unsuitable');

    setTimeout(function() {
      // Get image pixel dimensions 
      const screenImage = document.querySelector('.builder__preview-main-image');
      const imageWidth = parseInt(screenImage.getAttribute('data-crop-width'));
      const imageHeight = parseInt(screenImage.getAttribute('data-crop-height'));

      // Get print dimensions in inches
      const selectedPrint = document.querySelector('.builder__step--size .builder__option.active');
      const printWidth = parseFloat(selectedPrint.getAttribute('data-width'));
      const printHeight = parseFloat(selectedPrint.getAttribute('data-height')); 

      const imageDPI = Math.min(imageWidth, imageHeight) / Math.min(printWidth, printHeight);

      // Update image quality meter
      // if ($('.builder__preview').hasClass('flipped')) {
      //   var printWidth = parseFloat($('.builder__step--size .builder__option.active').data('height'));
      //   var printHeight = parseFloat($('.builder__step--size .builder__option.active').data('width'));
      // } else {
      //   var printWidth = parseFloat($('.builder__step--size .builder__option.active').data('width'));
      //   var printHeight = parseFloat($('.builder__step--size .builder__option.active').data('height'));
      // }

      // // Get short side of canvas
      // if (printWidth > printHeight) {
      //   var canvasShortSide = printHeight;
      // } else {
      //   var canvasShortSide = printWidth;
      // }

      // // Get short side of image
      // if (imageWidth > imageHeight) {
      //   var imageShortSide = imageHeight;
      // } else {
      //   var imageShortSide = imageWidth;
      // }

      // var imageDPI = imageShortSide / canvasShortSide;

      if (imageDPI > 100) {
        $('.builder__preview-quality-wrapper').removeClass('hidden');
        $('.builder__preview-quality').addClass('perfect');
      }

      if (imageDPI <= 100 && imageDPI >= 75) {
        $('.builder__preview-quality-wrapper').removeClass('hidden');
        $('.builder__preview-quality').addClass('good');
      }

      if (imageDPI < 75 && imageDPI >= 65) {
        $('.builder__preview-quality-wrapper').removeClass('hidden');
        $('.builder__preview-quality').addClass('fair');
      }

      if (imageDPI < 65) {
        $('.builder__preview-quality-wrapper').removeClass('hidden');
        $('.builder__preview-quality').addClass('unsuitable');
      }

      setTimeout(function() {
        if($('.builder__preview-quality').hasClass('unsuitable')) {
          $('.builder__preview-quality-message').html(`<span class="unsuitable-quality"><svg fill=none height=48 viewBox="0 0 48 48"width=48 xmlns=http://www.w3.org/2000/svg><circle cx=24 cy=24 fill=#F06161 r=24 /><g clip-path=url(#clip0_5737_3457)><path d="M24 35C30.0751 35 35 30.0751 35 24C35 17.9249 30.0751 13 24 13C17.9249 13 13 17.9249 13 24C13 30.0751 17.9249 35 24 35Z"stroke=black stroke-linecap=square stroke-miterlimit=10 stroke-width=2 /><path d="M24 19V25"stroke=black stroke-linecap=round stroke-miterlimit=10 stroke-width=2 /><path d="M24 30C24.5523 30 25 29.5523 25 29C25 28.4477 24.5523 28 24 28C23.4477 28 23 28.4477 23 29C23 29.5523 23.4477 30 24 30Z"fill=black /></g><defs><clipPath id=clip0_5737_3457><rect fill=white height=24 transform="translate(12 12)"width=24 /></clipPath></defs></svg> ${window.theme.builder.badQuality}</span>`);
          $('.builder__step--upload .builder__step-submit').attr('disabled', true);
        } else {
          $('.builder__preview-quality-message').html('');
          $('.builder__step--upload .builder__step-submit').removeAttr('disabled');
        }
        // if($('.builder__preview-quality').hasClass('perfect')) {
        //   $('.builder__preview-quality-message').html('<span>Your print will look Excellent!</span>');
        // } else if($('.builder__preview-quality').hasClass('good')) {
        //   $('.builder__preview-quality-message').html('<span>Your print will look Good</span>');
        // } else if($('.builder__preview-quality').hasClass('fair')) {
        //   $('.builder__preview-quality-message').html('<span>Your print will look Fair</span>');
        // } else if($('.builder__preview-quality').hasClass('unsuitable')) {
        //   $('.builder__preview-quality-message').html('<span class="unsuitable-quality">Your image quality is too low, please upload a new image or try a smaller print size.</span>');
        // }
      }, 200);
    }, 1000);
  }

  // =============================================
  // Add active class to current panel
  // =============================================
  function activeClasses() {
    $('.builder__preview-section').hover(function() {
      if(!$('body').hasClass('guillotine-dragging')) {
        $('.builder__preview-section').removeClass('active');
        $(this).addClass('active');
      }
    });

    $('.builder__preview-section').click(function() {
      $('.builder__preview-section').removeClass('focus');
      $(this).addClass('focus');
    });
  }

  // =============================================
  // Get querystring for state building
  // =============================================
  function getQueryStrings() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  }

  // =============================================
  // Select Frame
  // =============================================
  $('.builder__step--frame .builder__option').click(function(event) {
    if (event.target.closest('[data-frame-info-button]')) {
      var frameInfoButton = event.target.closest('[data-frame-info-button]');

      // Update preview frame
      var activeFrameImage = $(this).find('.builder__frame-wrap').attr('src');
      var activeFrameTitle = $(this).find('h4').text();

      if (activeFrameTitle != 'No Frame') {
        $('.framing-preview').addClass('frame-selected');
        $('.framing-preview .frame-wrap').attr('src',activeFrameImage);
      } else {
        $('.framing-preview').removeClass('frame-selected');
      }

      $('.drawer--frame-info').removeClass('black white espresso silver');
      $('.drawer--frame-info').addClass(frameInfoButton.getAttribute('data-frame-color'));

      $('[data-frame-info-title]').html(frameInfoButton.getAttribute('data-frame-title'));
      $('[data-frame-info-content]').html(frameInfoButton.getAttribute('data-frame-content'));
      $('[data-frame-info-toggle]').trigger('click');
    } else {
      if ($('.builder').hasClass('builder--has-edging')) {
        checkProgressEdging();
      } else {
        checkProgress();
      }

      // Get frame
      var frame = $(this).data('frame');
      var frameHandle = $(this).data('frame-handle');
      var frameColor = $(this).data('frame-color');
      var frameId = $(this).data('frame-id');
      var framePrice = $(this).find('span').text();

      // Add active class
      $('.builder__step--frame .builder__option').removeClass('active');
      $(this).addClass('active');

      // Update frame line item property
      $('.builder__line-frame').val(frameHandle);
      $('.builder__line-frame-variant').val(frameId);

      // Apply frame to preview
      $('.builder__preview-popup-wrap').attr('class','builder__preview-popup-wrap');
      $('.builder__preview-popup-wrap').addClass(frameColor);
      $('.builder__step--frame').removeClass('black white espresso silver');
      $('.builder__step--frame').addClass(frameColor);
      $('.drawer--frame-info').removeClass('black white espresso silver');
      $('.drawer--frame-info').addClass(frameColor);

      // Update large frame preview
      if ($(this).find('img').attr('src')) {
        $('.builder__selected-frame').attr('src', $(this).find('img').attr('src'));
        $('.builder__selected-frame').removeClass('hide');
      } else {
        $('.builder__selected-frame').addClass('hide');
      }

      // Update to frameless styling if frameless option
      if ($(this).hasClass('builder__option--frameless')) {
        $('.builder__step--frame').removeClass('frame-selected');
        $('.builder__summary-details-frame-wrap').hide();
      } else {
        $('.builder__step--frame').addClass('frame-selected');
        $('.builder__summary-details-frame-wrap').show();
      }

      // Update summary
      $('.builder__summary-details-frame').text(frame);
      $('.builder__summary-details-frame-price').text(framePrice);

      // Update continue button
      $('.builder__step--frame .builder__step-submit').text($('.builder__step--frame .builder__step-submit').data('continue-text'));
      $('.builder__step--frame .builder__step-submit').removeAttr('disabled');

      // Focus continue button
      $('.builder__step--frame .builder__step-submit').focus();

      // Triggr variant change
      $('.single-option-selector').trigger('change');

      // Update summary price
      var productPrice = $('.builder__summary-price.product-price').text().replace('$','');
      var framePriceRaw = framePrice.replace('$','').replace('+','');
      var updatedPrice = parseFloat(productPrice) + parseFloat(framePriceRaw);
      $('.builder__subtotal-value').text('$' + updatedPrice.toFixed(2));

      // If price is is greater than 150 show free shipping message
      if (updatedPrice > 150) {
        $('.builder__summary-free-shipping').removeClass('hide');
      } else {
        $('.builder__summary-free-shipping').addClass('hide');
      }

      // Update preview frame
      var activeFrameImage = $(this).find('.builder__frame-wrap').attr('src');
      var activeFrameTitle = $(this).find('h4').text();

      if (activeFrameTitle != 'No Frame') {
        $('.framing-preview').addClass('frame-selected');
        $('.framing-preview .frame-wrap').attr('src',activeFrameImage);
      } else {
        $('.framing-preview').removeClass('frame-selected');
      }
    }
  });

  // =============================================
  // Submit Frame
  // =============================================
  $('.builder__step--frame .builder__step-submit').click(function() {
    if ($(this).parents('.builder__step').find('.builder__option.active').length) {
      
      $('.builder__step--frame').removeClass('visible active');
      $('.builder__step--summary').addClass('visible active');

      // Pushing selected Frame event in GA4
      gtag('event', 'builder_selected_frame', {
        'selected_frame': `${$(this).closest('.builder__content-column').find('.builder__option.active').data('frame')}`
      });
    } else {
      alert(window.theme.builder.selectionError);
    }
  });

  // =============================================
  // Step controls
  // =============================================
  $('.builder__summary-change').click(function() {
    if ($(this).hasClass('builder__summary-change--next')) {
      if ($(this).parents('.builder__step--upload').length && $('.builder__step--upload .builder__step-submit').attr('disabled')) { return; }

      if ($(this).parents('.builder__step').find('.builder__option.active').length || $(this).parents('.builder__step--upload').find('.builder__preview.active').length) {
        var target = '#' + $(this).attr('data-section');
        $('.builder__step').removeClass('visible active');
        $(target).addClass('visible active');
        $(target).focus();
      } else {
        if ($(this).parents('.builder__step--upload').length) {
          alert(window.theme.builder.uploadError);
        } else {
          alert(window.theme.builder.selectionError);
        }
      }

      if ($(this).attr('data-section') == 'builder-upload') {
        builderCanvas();
      }
    } else {
      var target = '#' + $(this).attr('data-section');
      $('.builder__step').removeClass('visible active');
      $(target).addClass('visible active');
      $(target).focus();
    }
  });

  // =============================================
  // Frame preview
  // =============================================
  $('.builder__option--frame .icon-question').click(function() {
    var frameTitle = $(this).data('frame-title');
    var frameDescription = $(this).data('frame-description');
    var frameImages = $(this).data('frame-images').split(',');

    $.magnificPopup.open({
        type: 'inline',
        preloader: false,
        removalDelay: 500,
        mainClass: 'mfp-zoom-in',
        items: {
          src: '#builder-preview-popup'
        },
        callbacks: {
          open: function() {
            $('.builder__preview-product-title').text(frameTitle);

            // Show frame details & hide order details
            $('.builder__preview-product-title, .builder__preview-title').removeClass('hide');

            if(frameDescription != '') {
              $('.builder__preview-product-description').html(frameDescription);
              $('.builder__preview-product-description-title, .builder__preview-product-description').removeClass('hide');
            }

            if(frameImages != '') {
              $('.builder__preview-product-images').html('');

              var i;
              for (i = 0; i < frameImages.length; i++) {
                $('.builder__preview-product-images').append('<img src="'+frameImages[i]+'">');
              }

              $('.builder__preview-product-images-title, .builder__preview-product-images').removeClass('hide');
            }

            $('.builder__preview-popup .builder__order-details').addClass('hide');

            // Update close
            $('body .mfp-close').html('<span class="icon icon-x"></span>');
          },
          close: function() {
            // Hide frame details & show order details
            $('.builder__preview-product-title, .builder__preview-product-description-title, .builder__preview-product-description, .builder__preview-title, .builder__preview-product-images-title, .builder__preview-product-images').addClass('hide');
            $('.builder__preview-popup .builder__order-details').removeClass('hide');
          }
        }
    });
  });

  // =============================================
  // Resize redirect
  // =============================================
  $(window).resize(function() {
    if ($('.builder').hasClass('builder--two-panel-canvas') || $('.builder').hasClass('builder--three-panel-canvas')) {
      if (window.outerWidth < 1025) {
        $('.builder').addClass('hide');
        $('.builder-error').removeClass('hide');
      } else {
        $('.builder').removeClass('hide');
        $('.builder-error').addClass('hide');
      }
    }
  });

  $(window).load(function() {
    if ($('.builder').hasClass('builder--two-panel-canvas') || $('.builder').hasClass('builder--three-panel-canvas')) {
      if (window.outerWidth < 1025) {
        $('.builder').addClass('hide');
        $('.builder-error').removeClass('hide');
      }
    }
  });

  // =============================================
  // Submission
  // =============================================

  // Check progress on load
  if ($('.builder').hasClass('builder--has-edging')) {
    checkProgressEdging();
  } else {
    checkProgress();
  }

  // Check progress and enable / disable add to cart + preview buttons
  function checkProgress() {
    if ($('.builder__step').hasClass('builder__step--frame')) {
      setTimeout(function() {
        if ($('.builder__step--frame').hasClass('hide')) {
          if ($('.builder__summary-details-product').text() != ''
            && $('.builder__summary-details-layout').text() != ''
            && $('.builder__summary-details-size').text() != ''
            && !$('.builder__preview-quality').hasClass('unsuitable')
            && $('.builder__upload-photo').hasClass('hide')) {
            $('.builder__submit').removeClass('disabled');
            $('.builder__preview-btn').removeClass('disabled');
          } else {
            $('.builder__submit').addClass('disabled');
            $('.builder__preview-btn').addClass('disabled');
          }
        } else {
          if ($('.builder__summary-details-product').text() != ''
            && $('.builder__summary-details-layout').text() != ''
            && $('.builder__summary-details-size').text() != ''
            && $('.builder__summary-details-frame').text() != ''
            && $('.builder__step--frame .builder__option').hasClass('active')
            && !$('.builder__preview-quality').hasClass('unsuitable')
            && $('.builder__upload-photo').hasClass('hide')
            && !$('span').hasClass('unsuitable-quality')) {
            $('.builder__submit').removeClass('disabled');
            $('.builder__preview-btn').removeClass('disabled');
          } else {
            $('.builder__submit').addClass('disabled');
            $('.builder__preview-btn').addClass('disabled');
          }
        }
      }, 300);
    } else {
      setTimeout(function() {
        if ($('.builder__summary-details-product').text() != ''
          && $('.builder__summary-details-layout').text() != ''
          && $('.builder__summary-details-size').text() != ''
          && !$('.builder__preview-warning div').hasClass('builder__preview-error')
          && !$('.builder__preview-quality').hasClass('unsuitable')
          && $('.builder__upload-photo').hasClass('hide')) {
          $('.builder__submit').removeClass('disabled');
          $('.builder__preview-btn').removeClass('disabled');
        } else {
          $('.builder__submit').addClass('disabled');
          $('.builder__preview-btn').addClass('disabled');
        }
      }, 300);
    }
  }

  // Check progress and enable / disable add to cart + preview buttons, check edges as well
  function checkProgressEdging() {
    if ($('.builder__step').hasClass('builder__step--frame')) {
      setTimeout(function() {
        if ($('.builder__step--frame').hasClass('hide')) {
          if ($('.builder__summary-details-product').text() != ''
            && $('.builder__summary-details-layout').text() != ''
            && $('.builder__summary-details-size').text() != ''
            && $('.builder__summary-details-edge').text() != ''
            && !$('.builder__preview-warning div').hasClass('builder__preview-error')
            && !$('.builder__preview-quality').hasClass('unsuitable')
            && $('.builder__upload-photo').hasClass('hide')) {
            $('.builder__submit').removeClass('disabled');
            $('.builder__preview-btn').removeClass('disabled');
          } else {
            $('.builder__submit').addClass('disabled');
            $('.builder__preview-btn').addClass('disabled');
          }
        } else {
          if ($('.builder__summary-details-product').text() != ''
            && $('.builder__summary-details-layout').text() != ''
            && $('.builder__summary-details-size').text() != ''
            && $('.builder__summary-details-edge').text() != ''
            && $('.builder__summary-details-frame').text() != ''
            && $('.builder__step--frame .builder__option').hasClass('active')
            && !$('.builder__preview-warning div').hasClass('builder__preview-error')
            && !$('.builder__preview-quality').hasClass('unsuitable')
            && $('.builder__upload-photo').hasClass('hide')) {
            $('.builder__submit').removeClass('disabled');
            $('.builder__preview-btn').removeClass('disabled');
          } else {
            $('.builder__submit').addClass('disabled');
            $('.builder__preview-btn').addClass('disabled');
          }
        }
      }, 300);
    } else {
      setTimeout(function() {
        if ($('.builder__summary-details-product').text() != ''
          && $('.builder__summary-details-layout').text() != ''
          && $('.builder__summary-details-size').text() != ''
          && $('.builder__summary-details-edge').text() != ''
          && !$('.builder__preview-warning div').hasClass('builder__preview-error')
          && !$('.builder__preview-quality').hasClass('unsuitable')
          && $('.builder__upload-photo').hasClass('hide')) {
          $('.builder__submit').removeClass('disabled');
          $('.builder__preview-btn').removeClass('disabled');
        } else {
          $('.builder__submit').addClass('disabled');
          $('.builder__preview-btn').addClass('disabled');
        }
      }, 300);
    }
  }

  $('.builder__summary').submit(function() {
    $('.builder__summary-controls').addClass('hide');
    $('.builder__summary-success').removeClass('hide');
    $('.builder__overlay').addClass('active');
  });

  // On submission
  $('.builder__submit').click(async function() {
    
    // Generate random string for an id
    if ($('body .builder__line-id').val() == '') {
      var builderID = Math.floor(Math.random() * 100000000) + Math.floor(Math.random() * 100000000);
    } else {
      var builderID = $('.builder__line-id').val();
    }

    // Add submitting class
    $(this).addClass('submitting');

    // Apply id
    $('.builder__line-id').val(builderID);

    // Create variables for each line item
    var lineType = $('.builder__line-type').val();
    var lineSize = $('.builder__line-size').val();
    var lineImage = $('.builder__line-image').val();
    var lineEdge = $('.builder__line-edge').val();
    var lineEdgeColor = $('.builder__line-edge-color').val();
    var lineFrame = $('.builder__line-frame').val();
    var lineFrameVariant = $('.builder__line-frame-variant').val();
    var lineScale = $('.builder__line-scale').val();
    var lineX = $('.builder__line-x').val();
    var lineY = $('.builder__line-y').val();
    var lineOrientation = $('.builder__line-orientation').val();
    var lineFilter = $('.builder__line-image-filter').val();
    var lineEnhance = $('.builder__line-image-enhance').val();
    var lineID = $('.builder__line-id').val();
    var shopifyFile = $('.builder__line-shopify-file').val();
    var productHandle = $('.builder').data('product-handle');
    var linePermalink = 'https://'+window.location.hostname+'/products/'+productHandle+'?view=builder&type='+lineType+'&_size='+lineSize.replace('pouces', 'inches')+'&_image='+lineImage+'&edge='+lineEdge+'&edge-color='+lineEdgeColor+'&_frame='+lineFrame+'&_frame-variant='+lineFrameVariant+'&_scale='+lineScale+'&_x='+lineX+'&_y='+lineY+'&_orientation='+lineOrientation+'&image-filter='+lineFilter+'&image-enhance='+lineEnhance+'&_id='+lineID+'&_shopify-file='+shopifyFile

    // Add fallback incase edge was missed
    if($('.builder__step').hasClass('builder__step--edge') && lineEdge == '') {
      var lineEdge = $('.builder__step--edge .builder__option.active').data('edge');
      $('.builder__line-edge').val(lineEdge);
    }

    // Generate permalink line item
    $('.builder__line-permalink').val(linePermalink);

    // Grab all query strings
    if (window.location.href.indexOf('?') > 1) {
      // init getQueryStrings
      getQueryStrings();

      // Create variables for each querystring hash
      var type = getQueryStrings()['type'];
      var size = getQueryStrings()['_size'];
      var image = getQueryStrings()['_image'];
      var edge = getQueryStrings()['edge'];
      var edgeColor = getQueryStrings()['edge-color'];
      var frame = getQueryStrings()['_frame'];
      var frameVariant = getQueryStrings()['_frame-variant'];
      var scale = getQueryStrings()['_scale'];
      var x = getQueryStrings()['_x'];
      var y = getQueryStrings()['_y'];
      var orientation = getQueryStrings()['_orientation'];
      var filter = getQueryStrings()['image-filter'];
      var enhance = getQueryStrings()['image-enhance'];
      var id = getQueryStrings()['_id'];

      // If something has changed, resubmit, else just go to cart
      if (type != lineType                 ||
          size != lineSize                 ||
          image != lineImage               ||
          edge != lineEdge                 ||
          edgeColor != lineEdgeColor       ||
          frame != lineFrame               ||
          frameVariant != lineFrameVariant ||
          scale != lineScale               ||
          x != lineX                       ||
          y != lineY                       ||
          orientation != lineOrientation   ||
          filter != lineFilter             ||
          enhance != lineEnhance           ||
          id != lineID ) {

        // Upload image to shopify files section
        if (image != lineImage) {
          const uploadcareImage = $('.builder__line-image').val();
          const imageUrl = `${uploadcareImage}/-/resize/150x/}`;
          await uploadImageToShopify(imageUrl, linePermalink);
        }

        // Check if product has frame option
        if ($('.builder__step').hasClass('builder__step--frame')) {

          if (frame != lineFrame || frameVariant != lineFrameVariant || size != lineSize) {
            if ($('.builder__summary-details-frame').text().length) {
              var frameToAdd = $('.builder__option--frame.active').attr('data-frame-id');

              setTimeout(function() {
                jQuery.post('/cart/add.js', {
                  quantity: 1,
                  id: frameToAdd,
                  properties: {
                    '_frame-id': builderID
                  }
                });
              }, 100);
            }

            setTimeout(function() {
              addToCart();
            }, 1200);
          } else {
            addToCart();
          }

        // Product does not have hagning or frame options, so just submit
        } else {
          addToCart();
        }

      } else {
        if (!$('body').hasClass('lock')) {
          document.querySelector('[aria-controls="cart-drawer"]').click();
          $('.builder__submit').removeClass('submitting');
        }
      }
    } else {
      // Upload image to shopify files section
      const uploadcareImage = $('.builder__line-image').val();
      const imageUrl = `${uploadcareImage}/-/resize/150x/}`;
      await uploadImageToShopify(imageUrl, linePermalink);

      // Check if we have a frame and add it
      if ($('.builder__summary-details-frame').text().length) {

        var frameToAdd = $('.builder__option--frame.active').attr('data-frame-id');

        setTimeout(function() {
          jQuery.post('/cart/add.js', {
            quantity: 1,
            id: frameToAdd,
            properties: {
              '_frame-id': builderID
            }
          });
        }, 100);

        setTimeout(function() {
          addToCart();
        }, 1200);
      } else {
        addToCart();
      }
    }

    // Pushing item_added_to_cart event in GA4
    gtag('event', 'builder_item_add_to_cart', {
      'item_add_to_cart': true
    });
    
  });

  async function uploadImageToShopify(imageUrl, linePermalink) {
    const baseDomain = `https://${window.location.hostname}`
    const altText = ''

    try {
      const response = await fetch(`${baseDomain}/apps/file-upload/upload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          imageUrl,
          altText
        })
      })

      if (response.ok) {
        const result = await response.json()
        $('.builder__line-shopify-file').val(result);
        $('.builder__line-permalink').val(`${linePermalink.split('&_shopify-file=')[0]}&_shopify-file=${result}`);
      } else {
        console.log('Error uploading image: ' + response.statusText)
      }
    } catch (error) {
      console.log('Error uploading image: ' + error.message)
    }
  }

  function addToCart() {
    var parentForm = $('.builder__summary');
    var lineItemVariantId = parseInt(parentForm.find('[data-product-select]').val(), 10);
    var lineItemQuantity = 1;
    var lineItemProperties = {};
    var formInputs = parentForm.find('input, select, textarea');

    if (formInputs.length) {
      $(formInputs).each(function() {
        var nameAttr = $(this).attr('name');
        var typeAttr = $(this).attr('type');

        if (nameAttr && nameAttr.indexOf('properties') >= 0) {
          var propertyName = nameAttr.split('[')[1].replace(']', '');
          var propertyValue = '';

          if (typeAttr && typeAttr === 'radio' || typeAttr && typeAttr === 'checkbox') {
            if (formInput.checked === true) {
              propertyValue = $(this).val();
            }
          } else {
            propertyValue = $(this).val();
          }

          if (propertyValue !== '') {
            lineItemProperties[propertyName] = propertyValue;
          }
        }
      });
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: lineItemQuantity,
        id: lineItemVariantId,
        properties: lineItemProperties
      },
      dataType: 'json',
      success: function() {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.querySelector('[aria-controls="cart-drawer"]').click();

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("cart:validate"));
        }, 2000);

        $('.builder__submit').removeClass('submitting');
      }
    });
  }
}